webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _angularRoute = __webpack_require__(2);
	
	var _angularRoute2 = _interopRequireDefault(_angularRoute);
	
	var _angularResource = __webpack_require__(4);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularCookie = __webpack_require__(6);
	
	var _angularCookie2 = _interopRequireDefault(_angularCookie);
	
	var _angularSanitize = __webpack_require__(8);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _services = __webpack_require__(10);
	
	var services = _interopRequireWildcard(_services);
	
	var _controllers = __webpack_require__(24);
	
	var controllers = _interopRequireWildcard(_controllers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(60);
	
	var shimStringToJSON = function shimStringToJSON(val) {
	    if (typeof val == "string") {
	        return JSON.parse(val);
	    }
	    return val;
	};
	
	(function () {
	
	    var globalText = null;
	    var reportdata = {};
	    var disorderData = null;
	
	    var config = null;
	
	    var initInjector = angular.injector(['ng']);
	    var $http = initInjector.get("$http");
	
	    fetchConfig();
	
	    function fetchConfig() {
	
	        var location = window.location;
	        console.log(location.protocol + ' ' + location.host);
	        var configUrl = window.location.protocol + '//' + window.location.host + '/api/config';
	
	        console.log('configUrl: ' + configUrl);
	        return $http.get(configUrl).then(function (response) {
	
	            config = response.data;
	
	            fetchSampleData();
	            fetchDisorderData();
	        }, function (response) {
	            console.log('config response\n' + JSON.stringify(response.data, null, 2));
	        });
	    }
	
	    function fetchSampleData() {
	        var lastSlash = window.location.pathname.lastIndexOf("/");
	        var token = window.location.pathname.substring(lastSlash + 1, window.location.pathname.length);
	        var repoUrl = window.location.protocol + '//' + window.location.host + '/api/dnareport/' + token;
	
	        return $http.get(repoUrl).then(function (response) {
	
	            var results = response.data;
	            reportdata.resultString = shimStringToJSON(results.resultString);
	            reportdata.sampleDetails = shimStringToJSON(results.sampleDetails);
	            reportdata.reportDetails = shimStringToJSON(results.reportDetails);
	            reportdata.ancestryChartJSON = shimStringToJSON(results.ancestryChartJSON);
	            reportdata.locale = config.locale[reportdata.sampleDetails.testName];
	            fetchGlobalData();
	        }, function (response) {
	            console.log('response\n' + JSON.stringify(response.data, null, 2));
	        });
	    }
	
	    function fetchGlobalData() {
	
	        return $http.get(config.contentful.url + config.contentful.spaceid + '/entries/' + config.contentful.globaltextentryid + '/?access_token=' + config.contentful.access_token + '&locale=' + reportdata.locale).then(function (response) {
	            globalText = response.data.fields['globalText'];
	            bootstrapApplication();
	        });
	    }
	
	    function fetchDisorderData() {
	        return $http.get(config.contentful.url + config.contentful.spaceid + '/entries/?access_token=' + config.contentful.access_token + '&content_type=disorder&limit=250&select=sys.id,fields.diseaseLongName,fields.diseaseCategory,fields.diseaseName,' + 'fields.clinicalDescription,fields.keySigns,fields.onsetAge,fields.diseaseSeverity,fields.likelihood,fields.whatIsTheDisease,fields.vetandConsumerText,' + 'fields.twoCopyMale,fields.twoCopyFemale,fields.oneCopyMale,fields.oneCopyFemale,fields.enabled,fields.locusName,fields.modeOfInheritance&order=fields.diseaseCategory').then(function (response) {
	            disorderData = response.data.items;
	        });
	    }
	
	    function bootstrapApplication() {
	        angular.element(document.body).ready(function () {
	            var modules = [_angularRoute2.default, _angularSanitize2.default, _angularResource2.default, "ui.bootstrap", "mars.vet.dnareports.services", "mars.vet.dnareports.controllers"];
	
	            angular.module("mars.vet.dnareports.printreport.app", modules);
	            angular.module("mars.vet.dnareports.printreport.app").constant('config', config);
	            angular.module("mars.vet.dnareports.printreport.app").constant('reportdata', reportdata);
	            angular.module("mars.vet.dnareports.printreport.app").constant('globalText', globalText);
	            angular.module("mars.vet.dnareports.printreport.app").constant("disorderData", disorderData);
	            angular.bootstrap(document.body, ["mars.vet.dnareports.printreport.app"]);
	        });
	    }
	})();

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	module.exports = 'ngRoute';


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.6
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global shallowCopy: false */
	
	// `isArray` and `isObject` are necessary for `shallowCopy()` (included via `src/shallowCopy.js`).
	// They are initialized inside the `$RouteProvider`, to ensure `window.angular` is available.
	var isArray;
	var isObject;
	var isDefined;
	var noop;
	
	/**
	 * @ngdoc module
	 * @name ngRoute
	 * @description
	 *
	 * # ngRoute
	 *
	 * The `ngRoute` module provides routing and deeplinking services and directives for angular apps.
	 *
	 * ## Example
	 * See {@link ngRoute.$route#example $route} for an example of configuring and using `ngRoute`.
	 *
	 *
	 * <div doc-module-components="ngRoute"></div>
	 */
	/* global -ngRouteModule */
	var ngRouteModule = angular.
	  module('ngRoute', []).
	  info({ angularVersion: '1.6.6' }).
	  provider('$route', $RouteProvider).
	  // Ensure `$route` will be instantiated in time to capture the initial `$locationChangeSuccess`
	  // event (unless explicitly disabled). This is necessary in case `ngView` is included in an
	  // asynchronously loaded template.
	  run(instantiateRoute);
	var $routeMinErr = angular.$$minErr('ngRoute');
	var isEagerInstantiationEnabled;
	
	
	/**
	 * @ngdoc provider
	 * @name $routeProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring routes.
	 *
	 * ## Example
	 * See {@link ngRoute.$route#example $route} for an example of configuring and using `ngRoute`.
	 *
	 * ## Dependencies
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 */
	function $RouteProvider() {
	  isArray = angular.isArray;
	  isObject = angular.isObject;
	  isDefined = angular.isDefined;
	  noop = angular.noop;
	
	  function inherit(parent, extra) {
	    return angular.extend(Object.create(parent), extra);
	  }
	
	  var routes = {};
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#when
	   *
	   * @param {string} path Route path (matched against `$location.path`). If `$location.path`
	   *    contains redundant trailing slash or is missing one, the route will still match and the
	   *    `$location.path` will be updated to add or drop the trailing slash to exactly match the
	   *    route definition.
	   *
	   *    * `path` can contain named groups starting with a colon: e.g. `:name`. All characters up
	   *        to the next slash are matched and stored in `$routeParams` under the given `name`
	   *        when the route matches.
	   *    * `path` can contain named groups starting with a colon and ending with a star:
	   *        e.g.`:name*`. All characters are eagerly stored in `$routeParams` under the given `name`
	   *        when the route matches.
	   *    * `path` can contain optional named groups with a question mark: e.g.`:name?`.
	   *
	   *    For example, routes like `/color/:color/largecode/:largecode*\/edit` will match
	   *    `/color/brown/largecode/code/with/slashes/edit` and extract:
	   *
	   *    * `color: brown`
	   *    * `largecode: code/with/slashes`.
	   *
	   *
	   * @param {Object} route Mapping information to be assigned to `$route.current` on route
	   *    match.
	   *
	   *    Object properties:
	   *
	   *    - `controller` – `{(string|Function)=}` – Controller fn that should be associated with
	   *      newly created scope or the name of a {@link angular.Module#controller registered
	   *      controller} if passed as a string.
	   *    - `controllerAs` – `{string=}` – An identifier name for a reference to the controller.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *    - `template` – `{(string|Function)=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used by {@link
	   *      ngRoute.directive:ngView ngView} or {@link ng.directive:ngInclude ngInclude} directives.
	   *      This property takes precedence over `templateUrl`.
	   *
	   *      If `template` is a function, it will be called with the following parameters:
	   *
	   *      - `{Array.<Object>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route
	   *
	   *      One of `template` or `templateUrl` is required.
	   *
	   *    - `templateUrl` – `{(string|Function)=}` – path or function that returns a path to an html
	   *      template that should be used by {@link ngRoute.directive:ngView ngView}.
	   *
	   *      If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *      - `{Array.<Object>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route
	   *
	   *      One of `templateUrl` or `template` is required.
	   *
	   *    - `resolve` - `{Object.<string, Function>=}` - An optional map of dependencies which should
	   *      be injected into the controller. If any of these dependencies are promises, the router
	   *      will wait for them all to be resolved or one to be rejected before the controller is
	   *      instantiated.
	   *      If all the promises are resolved successfully, the values of the resolved promises are
	   *      injected and {@link ngRoute.$route#$routeChangeSuccess $routeChangeSuccess} event is
	   *      fired. If any of the promises are rejected the
	   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event is fired.
	   *      For easier access to the resolved dependencies from the template, the `resolve` map will
	   *      be available on the scope of the route, under `$resolve` (by default) or a custom name
	   *      specified by the `resolveAs` property (see below). This can be particularly useful, when
	   *      working with {@link angular.Module#component components} as route templates.<br />
	   *      <div class="alert alert-warning">
	   *        **Note:** If your scope already contains a property with this name, it will be hidden
	   *        or overwritten. Make sure, you specify an appropriate name for this property, that
	   *        does not collide with other properties on the scope.
	   *      </div>
	   *      The map object is:
	   *
	   *      - `key` – `{string}`: a name of a dependency to be injected into the controller.
	   *      - `factory` - `{string|Function}`: If `string` then it is an alias for a service.
	   *        Otherwise if function, then it is {@link auto.$injector#invoke injected}
	   *        and the return value is treated as the dependency. If the result is a promise, it is
	   *        resolved before its value is injected into the controller. Be aware that
	   *        `ngRoute.$routeParams` will still refer to the previous route within these resolve
	   *        functions.  Use `$route.current.params` to access the new route parameters, instead.
	   *
	   *    - `resolveAs` - `{string=}` - The name under which the `resolve` map will be available on
	   *      the scope of the route. If omitted, defaults to `$resolve`.
	   *
	   *    - `redirectTo` – `{(string|Function)=}` – value to update
	   *      {@link ng.$location $location} path with and trigger route redirection.
	   *
	   *      If `redirectTo` is a function, it will be called with the following parameters:
	   *
	   *      - `{Object.<string>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route templateUrl.
	   *      - `{string}` - current `$location.path()`
	   *      - `{Object}` - current `$location.search()`
	   *
	   *      The custom `redirectTo` function is expected to return a string which will be used
	   *      to update `$location.url()`. If the function throws an error, no further processing will
	   *      take place and the {@link ngRoute.$route#$routeChangeError $routeChangeError} event will
	   *      be fired.
	   *
	   *      Routes that specify `redirectTo` will not have their controllers, template functions
	   *      or resolves called, the `$location` will be changed to the redirect url and route
	   *      processing will stop. The exception to this is if the `redirectTo` is a function that
	   *      returns `undefined`. In this case the route transition occurs as though there was no
	   *      redirection.
	   *
	   *    - `resolveRedirectTo` – `{Function=}` – a function that will (eventually) return the value
	   *      to update {@link ng.$location $location} URL with and trigger route redirection. In
	   *      contrast to `redirectTo`, dependencies can be injected into `resolveRedirectTo` and the
	   *      return value can be either a string or a promise that will be resolved to a string.
	   *
	   *      Similar to `redirectTo`, if the return value is `undefined` (or a promise that gets
	   *      resolved to `undefined`), no redirection takes place and the route transition occurs as
	   *      though there was no redirection.
	   *
	   *      If the function throws an error or the returned promise gets rejected, no further
	   *      processing will take place and the
	   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event will be fired.
	   *
	   *      `redirectTo` takes precedence over `resolveRedirectTo`, so specifying both on the same
	   *      route definition, will cause the latter to be ignored.
	   *
	   *    - `[reloadOnSearch=true]` - `{boolean=}` - reload route when only `$location.search()`
	   *      or `$location.hash()` changes.
	   *
	   *      If the option is set to `false` and url in the browser changes, then
	   *      `$routeUpdate` event is broadcasted on the root scope.
	   *
	   *    - `[caseInsensitiveMatch=false]` - `{boolean=}` - match routes without being case sensitive
	   *
	   *      If the option is set to `true`, then the particular route can be matched without being
	   *      case sensitive
	   *
	   * @returns {Object} self
	   *
	   * @description
	   * Adds a new route definition to the `$route` service.
	   */
	  this.when = function(path, route) {
	    //copy original route object to preserve params inherited from proto chain
	    var routeCopy = shallowCopy(route);
	    if (angular.isUndefined(routeCopy.reloadOnSearch)) {
	      routeCopy.reloadOnSearch = true;
	    }
	    if (angular.isUndefined(routeCopy.caseInsensitiveMatch)) {
	      routeCopy.caseInsensitiveMatch = this.caseInsensitiveMatch;
	    }
	    routes[path] = angular.extend(
	      routeCopy,
	      path && pathRegExp(path, routeCopy)
	    );
	
	    // create redirection for trailing slashes
	    if (path) {
	      var redirectPath = (path[path.length - 1] === '/')
	            ? path.substr(0, path.length - 1)
	            : path + '/';
	
	      routes[redirectPath] = angular.extend(
	        {redirectTo: path},
	        pathRegExp(redirectPath, routeCopy)
	      );
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $routeProvider#caseInsensitiveMatch
	   * @description
	   *
	   * A boolean property indicating if routes defined
	   * using this provider should be matched using a case insensitive
	   * algorithm. Defaults to `false`.
	   */
	  this.caseInsensitiveMatch = false;
	
	   /**
	    * @param path {string} path
	    * @param opts {Object} options
	    * @return {?Object}
	    *
	    * @description
	    * Normalizes the given path, returning a regular expression
	    * and the original path.
	    *
	    * Inspired by pathRexp in visionmedia/express/lib/utils.js.
	    */
	  function pathRegExp(path, opts) {
	    var insensitive = opts.caseInsensitiveMatch,
	        ret = {
	          originalPath: path,
	          regexp: path
	        },
	        keys = ret.keys = [];
	
	    path = path
	      .replace(/([().])/g, '\\$1')
	      .replace(/(\/)?:(\w+)(\*\?|[?*])?/g, function(_, slash, key, option) {
	        var optional = (option === '?' || option === '*?') ? '?' : null;
	        var star = (option === '*' || option === '*?') ? '*' : null;
	        keys.push({ name: key, optional: !!optional });
	        slash = slash || '';
	        return ''
	          + (optional ? '' : slash)
	          + '(?:'
	          + (optional ? slash : '')
	          + (star && '(.+?)' || '([^/]+)')
	          + (optional || '')
	          + ')'
	          + (optional || '');
	      })
	      .replace(/([/$*])/g, '\\$1');
	
	    ret.regexp = new RegExp('^' + path + '$', insensitive ? 'i' : '');
	    return ret;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#otherwise
	   *
	   * @description
	   * Sets route definition that will be used on route change when no other route definition
	   * is matched.
	   *
	   * @param {Object|string} params Mapping information to be assigned to `$route.current`.
	   * If called with a string, the value maps to `redirectTo`.
	   * @returns {Object} self
	   */
	  this.otherwise = function(params) {
	    if (typeof params === 'string') {
	      params = {redirectTo: params};
	    }
	    this.when(null, params);
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#eagerInstantiationEnabled
	   * @kind function
	   *
	   * @description
	   * Call this method as a setter to enable/disable eager instantiation of the
	   * {@link ngRoute.$route $route} service upon application bootstrap. You can also call it as a
	   * getter (i.e. without any arguments) to get the current value of the
	   * `eagerInstantiationEnabled` flag.
	   *
	   * Instantiating `$route` early is necessary for capturing the initial
	   * {@link ng.$location#$locationChangeStart $locationChangeStart} event and navigating to the
	   * appropriate route. Usually, `$route` is instantiated in time by the
	   * {@link ngRoute.ngView ngView} directive. Yet, in cases where `ngView` is included in an
	   * asynchronously loaded template (e.g. in another directive's template), the directive factory
	   * might not be called soon enough for `$route` to be instantiated _before_ the initial
	   * `$locationChangeSuccess` event is fired. Eager instantiation ensures that `$route` is always
	   * instantiated in time, regardless of when `ngView` will be loaded.
	   *
	   * The default value is true.
	   *
	   * **Note**:<br />
	   * You may want to disable the default behavior when unit-testing modules that depend on
	   * `ngRoute`, in order to avoid an unexpected request for the default route's template.
	   *
	   * @param {boolean=} enabled - If provided, update the internal `eagerInstantiationEnabled` flag.
	   *
	   * @returns {*} The current value of the `eagerInstantiationEnabled` flag if used as a getter or
	   *     itself (for chaining) if used as a setter.
	   */
	  isEagerInstantiationEnabled = true;
	  this.eagerInstantiationEnabled = function eagerInstantiationEnabled(enabled) {
	    if (isDefined(enabled)) {
	      isEagerInstantiationEnabled = enabled;
	      return this;
	    }
	
	    return isEagerInstantiationEnabled;
	  };
	
	
	  this.$get = ['$rootScope',
	               '$location',
	               '$routeParams',
	               '$q',
	               '$injector',
	               '$templateRequest',
	               '$sce',
	               '$browser',
	      function($rootScope, $location, $routeParams, $q, $injector, $templateRequest, $sce, $browser) {
	
	    /**
	     * @ngdoc service
	     * @name $route
	     * @requires $location
	     * @requires $routeParams
	     *
	     * @property {Object} current Reference to the current route definition.
	     * The route definition contains:
	     *
	     *   - `controller`: The controller constructor as defined in the route definition.
	     *   - `locals`: A map of locals which is used by {@link ng.$controller $controller} service for
	     *     controller instantiation. The `locals` contain
	     *     the resolved values of the `resolve` map. Additionally the `locals` also contain:
	     *
	     *     - `$scope` - The current route scope.
	     *     - `$template` - The current route template HTML.
	     *
	     *     The `locals` will be assigned to the route scope's `$resolve` property. You can override
	     *     the property name, using `resolveAs` in the route definition. See
	     *     {@link ngRoute.$routeProvider $routeProvider} for more info.
	     *
	     * @property {Object} routes Object with all route configuration Objects as its properties.
	     *
	     * @description
	     * `$route` is used for deep-linking URLs to controllers and views (HTML partials).
	     * It watches `$location.url()` and tries to map the path to an existing route definition.
	     *
	     * Requires the {@link ngRoute `ngRoute`} module to be installed.
	     *
	     * You can define routes through {@link ngRoute.$routeProvider $routeProvider}'s API.
	     *
	     * The `$route` service is typically used in conjunction with the
	     * {@link ngRoute.directive:ngView `ngView`} directive and the
	     * {@link ngRoute.$routeParams `$routeParams`} service.
	     *
	     * @example
	     * This example shows how changing the URL hash causes the `$route` to match a route against the
	     * URL, and the `ngView` pulls in the partial.
	     *
	     * <example name="$route-service" module="ngRouteExample"
	     *          deps="angular-route.js" fixBase="true">
	     *   <file name="index.html">
	     *     <div ng-controller="MainController">
	     *       Choose:
	     *       <a href="Book/Moby">Moby</a> |
	     *       <a href="Book/Moby/ch/1">Moby: Ch1</a> |
	     *       <a href="Book/Gatsby">Gatsby</a> |
	     *       <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
	     *       <a href="Book/Scarlet">Scarlet Letter</a><br/>
	     *
	     *       <div ng-view></div>
	     *
	     *       <hr />
	     *
	     *       <pre>$location.path() = {{$location.path()}}</pre>
	     *       <pre>$route.current.templateUrl = {{$route.current.templateUrl}}</pre>
	     *       <pre>$route.current.params = {{$route.current.params}}</pre>
	     *       <pre>$route.current.scope.name = {{$route.current.scope.name}}</pre>
	     *       <pre>$routeParams = {{$routeParams}}</pre>
	     *     </div>
	     *   </file>
	     *
	     *   <file name="book.html">
	     *     controller: {{name}}<br />
	     *     Book Id: {{params.bookId}}<br />
	     *   </file>
	     *
	     *   <file name="chapter.html">
	     *     controller: {{name}}<br />
	     *     Book Id: {{params.bookId}}<br />
	     *     Chapter Id: {{params.chapterId}}
	     *   </file>
	     *
	     *   <file name="script.js">
	     *     angular.module('ngRouteExample', ['ngRoute'])
	     *
	     *      .controller('MainController', function($scope, $route, $routeParams, $location) {
	     *          $scope.$route = $route;
	     *          $scope.$location = $location;
	     *          $scope.$routeParams = $routeParams;
	     *      })
	     *
	     *      .controller('BookController', function($scope, $routeParams) {
	     *          $scope.name = 'BookController';
	     *          $scope.params = $routeParams;
	     *      })
	     *
	     *      .controller('ChapterController', function($scope, $routeParams) {
	     *          $scope.name = 'ChapterController';
	     *          $scope.params = $routeParams;
	     *      })
	     *
	     *     .config(function($routeProvider, $locationProvider) {
	     *       $routeProvider
	     *        .when('/Book/:bookId', {
	     *         templateUrl: 'book.html',
	     *         controller: 'BookController',
	     *         resolve: {
	     *           // I will cause a 1 second delay
	     *           delay: function($q, $timeout) {
	     *             var delay = $q.defer();
	     *             $timeout(delay.resolve, 1000);
	     *             return delay.promise;
	     *           }
	     *         }
	     *       })
	     *       .when('/Book/:bookId/ch/:chapterId', {
	     *         templateUrl: 'chapter.html',
	     *         controller: 'ChapterController'
	     *       });
	     *
	     *       // configure html5 to get links working on jsfiddle
	     *       $locationProvider.html5Mode(true);
	     *     });
	     *
	     *   </file>
	     *
	     *   <file name="protractor.js" type="protractor">
	     *     it('should load and compile correct template', function() {
	     *       element(by.linkText('Moby: Ch1')).click();
	     *       var content = element(by.css('[ng-view]')).getText();
	     *       expect(content).toMatch(/controller: ChapterController/);
	     *       expect(content).toMatch(/Book Id: Moby/);
	     *       expect(content).toMatch(/Chapter Id: 1/);
	     *
	     *       element(by.partialLinkText('Scarlet')).click();
	     *
	     *       content = element(by.css('[ng-view]')).getText();
	     *       expect(content).toMatch(/controller: BookController/);
	     *       expect(content).toMatch(/Book Id: Scarlet/);
	     *     });
	     *   </file>
	     * </example>
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeStart
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted before a route change. At this  point the route services starts
	     * resolving all of the dependencies needed for the route change to occur.
	     * Typically this involves fetching the view template as well as any dependencies
	     * defined in `resolve` route property. Once  all of the dependencies are resolved
	     * `$routeChangeSuccess` is fired.
	     *
	     * The route change (and the `$location` change that triggered it) can be prevented
	     * by calling `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on}
	     * for more details about event object.
	     *
	     * @param {Object} angularEvent Synthetic event object.
	     * @param {Route} next Future route information.
	     * @param {Route} current Current route information.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeSuccess
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted after a route change has happened successfully.
	     * The `resolve` dependencies are now available in the `current.locals` property.
	     *
	     * {@link ngRoute.directive:ngView ngView} listens for the directive
	     * to instantiate the controller and render the view.
	     *
	     * @param {Object} angularEvent Synthetic event object.
	     * @param {Route} current Current route information.
	     * @param {Route|Undefined} previous Previous route information, or undefined if current is
	     * first route entered.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeError
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted if a redirection function fails or any redirection or resolve promises are
	     * rejected.
	     *
	     * @param {Object} angularEvent Synthetic event object
	     * @param {Route} current Current route information.
	     * @param {Route} previous Previous route information.
	     * @param {Route} rejection The thrown error or the rejection reason of the promise. Usually
	     * the rejection reason is the error that caused the promise to get rejected.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeUpdate
	     * @eventType broadcast on root scope
	     * @description
	     * The `reloadOnSearch` property has been set to false, and we are reusing the same
	     * instance of the Controller.
	     *
	     * @param {Object} angularEvent Synthetic event object
	     * @param {Route} current Current/previous route information.
	     */
	
	    var forceReload = false,
	        preparedRoute,
	        preparedRouteIsUpdateOnly,
	        $route = {
	          routes: routes,
	
	          /**
	           * @ngdoc method
	           * @name $route#reload
	           *
	           * @description
	           * Causes `$route` service to reload the current route even if
	           * {@link ng.$location $location} hasn't changed.
	           *
	           * As a result of that, {@link ngRoute.directive:ngView ngView}
	           * creates new scope and reinstantiates the controller.
	           */
	          reload: function() {
	            forceReload = true;
	
	            var fakeLocationEvent = {
	              defaultPrevented: false,
	              preventDefault: function fakePreventDefault() {
	                this.defaultPrevented = true;
	                forceReload = false;
	              }
	            };
	
	            $rootScope.$evalAsync(function() {
	              prepareRoute(fakeLocationEvent);
	              if (!fakeLocationEvent.defaultPrevented) commitRoute();
	            });
	          },
	
	          /**
	           * @ngdoc method
	           * @name $route#updateParams
	           *
	           * @description
	           * Causes `$route` service to update the current URL, replacing
	           * current route parameters with those specified in `newParams`.
	           * Provided property names that match the route's path segment
	           * definitions will be interpolated into the location's path, while
	           * remaining properties will be treated as query params.
	           *
	           * @param {!Object<string, string>} newParams mapping of URL parameter names to values
	           */
	          updateParams: function(newParams) {
	            if (this.current && this.current.$$route) {
	              newParams = angular.extend({}, this.current.params, newParams);
	              $location.path(interpolate(this.current.$$route.originalPath, newParams));
	              // interpolate modifies newParams, only query params are left
	              $location.search(newParams);
	            } else {
	              throw $routeMinErr('norout', 'Tried updating route when with no current route');
	            }
	          }
	        };
	
	    $rootScope.$on('$locationChangeStart', prepareRoute);
	    $rootScope.$on('$locationChangeSuccess', commitRoute);
	
	    return $route;
	
	    /////////////////////////////////////////////////////
	
	    /**
	     * @param on {string} current url
	     * @param route {Object} route regexp to match the url against
	     * @return {?Object}
	     *
	     * @description
	     * Check if the route matches the current url.
	     *
	     * Inspired by match in
	     * visionmedia/express/lib/router/router.js.
	     */
	    function switchRouteMatcher(on, route) {
	      var keys = route.keys,
	          params = {};
	
	      if (!route.regexp) return null;
	
	      var m = route.regexp.exec(on);
	      if (!m) return null;
	
	      for (var i = 1, len = m.length; i < len; ++i) {
	        var key = keys[i - 1];
	
	        var val = m[i];
	
	        if (key && val) {
	          params[key.name] = val;
	        }
	      }
	      return params;
	    }
	
	    function prepareRoute($locationEvent) {
	      var lastRoute = $route.current;
	
	      preparedRoute = parseRoute();
	      preparedRouteIsUpdateOnly = preparedRoute && lastRoute && preparedRoute.$$route === lastRoute.$$route
	          && angular.equals(preparedRoute.pathParams, lastRoute.pathParams)
	          && !preparedRoute.reloadOnSearch && !forceReload;
	
	      if (!preparedRouteIsUpdateOnly && (lastRoute || preparedRoute)) {
	        if ($rootScope.$broadcast('$routeChangeStart', preparedRoute, lastRoute).defaultPrevented) {
	          if ($locationEvent) {
	            $locationEvent.preventDefault();
	          }
	        }
	      }
	    }
	
	    function commitRoute() {
	      var lastRoute = $route.current;
	      var nextRoute = preparedRoute;
	
	      if (preparedRouteIsUpdateOnly) {
	        lastRoute.params = nextRoute.params;
	        angular.copy(lastRoute.params, $routeParams);
	        $rootScope.$broadcast('$routeUpdate', lastRoute);
	      } else if (nextRoute || lastRoute) {
	        forceReload = false;
	        $route.current = nextRoute;
	
	        var nextRoutePromise = $q.resolve(nextRoute);
	
	        $browser.$$incOutstandingRequestCount();
	
	        nextRoutePromise.
	          then(getRedirectionData).
	          then(handlePossibleRedirection).
	          then(function(keepProcessingRoute) {
	            return keepProcessingRoute && nextRoutePromise.
	              then(resolveLocals).
	              then(function(locals) {
	                // after route change
	                if (nextRoute === $route.current) {
	                  if (nextRoute) {
	                    nextRoute.locals = locals;
	                    angular.copy(nextRoute.params, $routeParams);
	                  }
	                  $rootScope.$broadcast('$routeChangeSuccess', nextRoute, lastRoute);
	                }
	              });
	          }).catch(function(error) {
	            if (nextRoute === $route.current) {
	              $rootScope.$broadcast('$routeChangeError', nextRoute, lastRoute, error);
	            }
	          }).finally(function() {
	            // Because `commitRoute()` is called from a `$rootScope.$evalAsync` block (see
	            // `$locationWatch`), this `$$completeOutstandingRequest()` call will not cause
	            // `outstandingRequestCount` to hit zero.  This is important in case we are redirecting
	            // to a new route which also requires some asynchronous work.
	
	            $browser.$$completeOutstandingRequest(noop);
	          });
	      }
	    }
	
	    function getRedirectionData(route) {
	      var data = {
	        route: route,
	        hasRedirection: false
	      };
	
	      if (route) {
	        if (route.redirectTo) {
	          if (angular.isString(route.redirectTo)) {
	            data.path = interpolate(route.redirectTo, route.params);
	            data.search = route.params;
	            data.hasRedirection = true;
	          } else {
	            var oldPath = $location.path();
	            var oldSearch = $location.search();
	            var newUrl = route.redirectTo(route.pathParams, oldPath, oldSearch);
	
	            if (angular.isDefined(newUrl)) {
	              data.url = newUrl;
	              data.hasRedirection = true;
	            }
	          }
	        } else if (route.resolveRedirectTo) {
	          return $q.
	            resolve($injector.invoke(route.resolveRedirectTo)).
	            then(function(newUrl) {
	              if (angular.isDefined(newUrl)) {
	                data.url = newUrl;
	                data.hasRedirection = true;
	              }
	
	              return data;
	            });
	        }
	      }
	
	      return data;
	    }
	
	    function handlePossibleRedirection(data) {
	      var keepProcessingRoute = true;
	
	      if (data.route !== $route.current) {
	        keepProcessingRoute = false;
	      } else if (data.hasRedirection) {
	        var oldUrl = $location.url();
	        var newUrl = data.url;
	
	        if (newUrl) {
	          $location.
	            url(newUrl).
	            replace();
	        } else {
	          newUrl = $location.
	            path(data.path).
	            search(data.search).
	            replace().
	            url();
	        }
	
	        if (newUrl !== oldUrl) {
	          // Exit out and don't process current next value,
	          // wait for next location change from redirect
	          keepProcessingRoute = false;
	        }
	      }
	
	      return keepProcessingRoute;
	    }
	
	    function resolveLocals(route) {
	      if (route) {
	        var locals = angular.extend({}, route.resolve);
	        angular.forEach(locals, function(value, key) {
	          locals[key] = angular.isString(value) ?
	              $injector.get(value) :
	              $injector.invoke(value, null, null, key);
	        });
	        var template = getTemplateFor(route);
	        if (angular.isDefined(template)) {
	          locals['$template'] = template;
	        }
	        return $q.all(locals);
	      }
	    }
	
	    function getTemplateFor(route) {
	      var template, templateUrl;
	      if (angular.isDefined(template = route.template)) {
	        if (angular.isFunction(template)) {
	          template = template(route.params);
	        }
	      } else if (angular.isDefined(templateUrl = route.templateUrl)) {
	        if (angular.isFunction(templateUrl)) {
	          templateUrl = templateUrl(route.params);
	        }
	        if (angular.isDefined(templateUrl)) {
	          route.loadedTemplateUrl = $sce.valueOf(templateUrl);
	          template = $templateRequest(templateUrl);
	        }
	      }
	      return template;
	    }
	
	    /**
	     * @returns {Object} the current active route, by matching it against the URL
	     */
	    function parseRoute() {
	      // Match a route
	      var params, match;
	      angular.forEach(routes, function(route, path) {
	        if (!match && (params = switchRouteMatcher($location.path(), route))) {
	          match = inherit(route, {
	            params: angular.extend({}, $location.search(), params),
	            pathParams: params});
	          match.$$route = route;
	        }
	      });
	      // No route matched; fallback to "otherwise" route
	      return match || routes[null] && inherit(routes[null], {params: {}, pathParams:{}});
	    }
	
	    /**
	     * @returns {string} interpolation of the redirect path with the parameters
	     */
	    function interpolate(string, params) {
	      var result = [];
	      angular.forEach((string || '').split(':'), function(segment, i) {
	        if (i === 0) {
	          result.push(segment);
	        } else {
	          var segmentMatch = segment.match(/(\w+)(?:[?*])?(.*)/);
	          var key = segmentMatch[1];
	          result.push(params[key]);
	          result.push(segmentMatch[2] || '');
	          delete params[key];
	        }
	      });
	      return result.join('');
	    }
	  }];
	}
	
	instantiateRoute.$inject = ['$injector'];
	function instantiateRoute($injector) {
	  if (isEagerInstantiationEnabled) {
	    // Instantiate `$route`
	    $injector.get('$route');
	  }
	}
	
	ngRouteModule.provider('$routeParams', $RouteParamsProvider);
	
	
	/**
	 * @ngdoc service
	 * @name $routeParams
	 * @requires $route
	 * @this
	 *
	 * @description
	 * The `$routeParams` service allows you to retrieve the current set of route parameters.
	 *
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 *
	 * The route parameters are a combination of {@link ng.$location `$location`}'s
	 * {@link ng.$location#search `search()`} and {@link ng.$location#path `path()`}.
	 * The `path` parameters are extracted when the {@link ngRoute.$route `$route`} path is matched.
	 *
	 * In case of parameter name collision, `path` params take precedence over `search` params.
	 *
	 * The service guarantees that the identity of the `$routeParams` object will remain unchanged
	 * (but its properties will likely change) even when a route change occurs.
	 *
	 * Note that the `$routeParams` are only updated *after* a route change completes successfully.
	 * This means that you cannot rely on `$routeParams` being correct in route resolve functions.
	 * Instead you can use `$route.current.params` to access the new route's parameters.
	 *
	 * @example
	 * ```js
	 *  // Given:
	 *  // URL: http://server.com/index.html#/Chapter/1/Section/2?search=moby
	 *  // Route: /Chapter/:chapterId/Section/:sectionId
	 *  //
	 *  // Then
	 *  $routeParams ==> {chapterId:'1', sectionId:'2', search:'moby'}
	 * ```
	 */
	function $RouteParamsProvider() {
	  this.$get = function() { return {}; };
	}
	
	ngRouteModule.directive('ngView', ngViewFactory);
	ngRouteModule.directive('ngView', ngViewFillContentFactory);
	
	
	/**
	 * @ngdoc directive
	 * @name ngView
	 * @restrict ECA
	 *
	 * @description
	 * # Overview
	 * `ngView` is a directive that complements the {@link ngRoute.$route $route} service by
	 * including the rendered template of the current route into the main layout (`index.html`) file.
	 * Every time the current route changes, the included view changes with it according to the
	 * configuration of the `$route` service.
	 *
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from to the DOM  |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 *
	 * @param {string=} autoscroll Whether `ngView` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the view is updated.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the `autoscroll` attribute value evaluated
	 *                    as an expression yields a truthy value.
	 * @example
	    <example name="ngView-directive" module="ngViewExample"
	             deps="angular-route.js;angular-animate.js"
	             animations="true" fixBase="true">
	      <file name="index.html">
	        <div ng-controller="MainCtrl as main">
	          Choose:
	          <a href="Book/Moby">Moby</a> |
	          <a href="Book/Moby/ch/1">Moby: Ch1</a> |
	          <a href="Book/Gatsby">Gatsby</a> |
	          <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
	          <a href="Book/Scarlet">Scarlet Letter</a><br/>
	
	          <div class="view-animate-container">
	            <div ng-view class="view-animate"></div>
	          </div>
	          <hr />
	
	          <pre>$location.path() = {{main.$location.path()}}</pre>
	          <pre>$route.current.templateUrl = {{main.$route.current.templateUrl}}</pre>
	          <pre>$route.current.params = {{main.$route.current.params}}</pre>
	          <pre>$routeParams = {{main.$routeParams}}</pre>
	        </div>
	      </file>
	
	      <file name="book.html">
	        <div>
	          controller: {{book.name}}<br />
	          Book Id: {{book.params.bookId}}<br />
	        </div>
	      </file>
	
	      <file name="chapter.html">
	        <div>
	          controller: {{chapter.name}}<br />
	          Book Id: {{chapter.params.bookId}}<br />
	          Chapter Id: {{chapter.params.chapterId}}
	        </div>
	      </file>
	
	      <file name="animations.css">
	        .view-animate-container {
	          position:relative;
	          height:100px!important;
	          background:white;
	          border:1px solid black;
	          height:40px;
	          overflow:hidden;
	        }
	
	        .view-animate {
	          padding:10px;
	        }
	
	        .view-animate.ng-enter, .view-animate.ng-leave {
	          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 1.5s;
	
	          display:block;
	          width:100%;
	          border-left:1px solid black;
	
	          position:absolute;
	          top:0;
	          left:0;
	          right:0;
	          bottom:0;
	          padding:10px;
	        }
	
	        .view-animate.ng-enter {
	          left:100%;
	        }
	        .view-animate.ng-enter.ng-enter-active {
	          left:0;
	        }
	        .view-animate.ng-leave.ng-leave-active {
	          left:-100%;
	        }
	      </file>
	
	      <file name="script.js">
	        angular.module('ngViewExample', ['ngRoute', 'ngAnimate'])
	          .config(['$routeProvider', '$locationProvider',
	            function($routeProvider, $locationProvider) {
	              $routeProvider
	                .when('/Book/:bookId', {
	                  templateUrl: 'book.html',
	                  controller: 'BookCtrl',
	                  controllerAs: 'book'
	                })
	                .when('/Book/:bookId/ch/:chapterId', {
	                  templateUrl: 'chapter.html',
	                  controller: 'ChapterCtrl',
	                  controllerAs: 'chapter'
	                });
	
	              $locationProvider.html5Mode(true);
	          }])
	          .controller('MainCtrl', ['$route', '$routeParams', '$location',
	            function MainCtrl($route, $routeParams, $location) {
	              this.$route = $route;
	              this.$location = $location;
	              this.$routeParams = $routeParams;
	          }])
	          .controller('BookCtrl', ['$routeParams', function BookCtrl($routeParams) {
	            this.name = 'BookCtrl';
	            this.params = $routeParams;
	          }])
	          .controller('ChapterCtrl', ['$routeParams', function ChapterCtrl($routeParams) {
	            this.name = 'ChapterCtrl';
	            this.params = $routeParams;
	          }]);
	
	      </file>
	
	      <file name="protractor.js" type="protractor">
	        it('should load and compile correct template', function() {
	          element(by.linkText('Moby: Ch1')).click();
	          var content = element(by.css('[ng-view]')).getText();
	          expect(content).toMatch(/controller: ChapterCtrl/);
	          expect(content).toMatch(/Book Id: Moby/);
	          expect(content).toMatch(/Chapter Id: 1/);
	
	          element(by.partialLinkText('Scarlet')).click();
	
	          content = element(by.css('[ng-view]')).getText();
	          expect(content).toMatch(/controller: BookCtrl/);
	          expect(content).toMatch(/Book Id: Scarlet/);
	        });
	      </file>
	    </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngView#$viewContentLoaded
	 * @eventType emit on the current ngView scope
	 * @description
	 * Emitted every time the ngView content is reloaded.
	 */
	ngViewFactory.$inject = ['$route', '$anchorScroll', '$animate'];
	function ngViewFactory($route, $anchorScroll, $animate) {
	  return {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    link: function(scope, $element, attr, ctrl, $transclude) {
	        var currentScope,
	            currentElement,
	            previousLeaveAnimation,
	            autoScrollExp = attr.autoscroll,
	            onloadExp = attr.onload || '';
	
	        scope.$on('$routeChangeSuccess', update);
	        update();
	
	        function cleanupLastView() {
	          if (previousLeaveAnimation) {
	            $animate.cancel(previousLeaveAnimation);
	            previousLeaveAnimation = null;
	          }
	
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            previousLeaveAnimation = $animate.leave(currentElement);
	            previousLeaveAnimation.done(function(response) {
	              if (response !== false) previousLeaveAnimation = null;
	            });
	            currentElement = null;
	          }
	        }
	
	        function update() {
	          var locals = $route.current && $route.current.locals,
	              template = locals && locals.$template;
	
	          if (angular.isDefined(template)) {
	            var newScope = scope.$new();
	            var current = $route.current;
	
	            // Note: This will also link all children of ng-view that were contained in the original
	            // html. If that content contains controllers, ... they could pollute/change the scope.
	            // However, using ng-view on an element with additional content does not make sense...
	            // Note: We can't remove them in the cloneAttchFn of $transclude as that
	            // function is called before linking the content, which would apply child
	            // directives to non existing elements.
	            var clone = $transclude(newScope, function(clone) {
	              $animate.enter(clone, null, currentElement || $element).done(function onNgViewEnter(response) {
	                if (response !== false && angular.isDefined(autoScrollExp)
	                  && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                  $anchorScroll();
	                }
	              });
	              cleanupLastView();
	            });
	
	            currentElement = clone;
	            currentScope = current.scope = newScope;
	            currentScope.$emit('$viewContentLoaded');
	            currentScope.$eval(onloadExp);
	          } else {
	            cleanupLastView();
	          }
	        }
	    }
	  };
	}
	
	// This directive is called during the $transclude call of the first `ngView` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngView
	// is called.
	ngViewFillContentFactory.$inject = ['$compile', '$controller', '$route'];
	function ngViewFillContentFactory($compile, $controller, $route) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    link: function(scope, $element) {
	      var current = $route.current,
	          locals = current.locals;
	
	      $element.html(locals.$template);
	
	      var link = $compile($element.contents());
	
	      if (current.controller) {
	        locals.$scope = scope;
	        var controller = $controller(current.controller, locals);
	        if (current.controllerAs) {
	          scope[current.controllerAs] = controller;
	        }
	        $element.data('$ngControllerController', controller);
	        $element.children().data('$ngControllerController', controller);
	      }
	      scope[current.resolveAs || '$resolve'] = locals;
	
	      link(scope);
	    }
	  };
	}
	
	
	})(window, window.angular);


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(9);
	module.exports = 'ngSanitize';


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.6
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isDefined;
	var lowercase;
	var noop;
	var nodeContains;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isDefined = angular.isDefined;
	  lowercase = angular.lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
	    // eslint-disable-next-line no-bitwise
	    return !!(this.compareDocumentPosition(arg) & 16);
	  };
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = toMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = toMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = toMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, toMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, toMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = toMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = toMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = toMap('background,cite,href,longdesc,src,xlink:href');
	
	  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function toMap(str, lowercaseKeys) {
	    var obj = {}, items = str.split(','), i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  /**
	   * Create an inert document that contains the dirty HTML that needs sanitizing
	   * Depending upon browser support we use one of three strategies for doing this.
	   * Support: Safari 10.x -> XHR strategy
	   * Support: Firefox -> DomParser strategy
	   */
	  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
	    var inertDocument;
	    if (document && document.implementation) {
	      inertDocument = document.implementation.createHTMLDocument('inert');
	    } else {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');
	
	    // Check for the Safari 10.1 bug - which allows JS to run inside the SVG G element
	    inertBodyElement.innerHTML = '<svg><g onload="this.parentNode.remove()"></g></svg>';
	    if (!inertBodyElement.querySelector('svg')) {
	      return getInertBodyElement_XHR;
	    } else {
	      // Check for the Firefox bug - which prevents the inner img JS from being sanitized
	      inertBodyElement.innerHTML = '<svg><p><style><img src="</style><img src=x onerror=alert(1)//">';
	      if (inertBodyElement.querySelector('svg img')) {
	        return getInertBodyElement_DOMParser;
	      } else {
	        return getInertBodyElement_InertDocument;
	      }
	    }
	
	    function getInertBodyElement_XHR(html) {
	      // We add this dummy element to ensure that the rest of the content is parsed as expected
	      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
	      html = '<remove></remove>' + html;
	      try {
	        html = encodeURI(html);
	      } catch (e) {
	        return undefined;
	      }
	      var xhr = new window.XMLHttpRequest();
	      xhr.responseType = 'document';
	      xhr.open('GET', 'data:text/html;charset=utf-8,' + html, false);
	      xhr.send(null);
	      var body = xhr.response.body;
	      body.firstChild.remove();
	      return body;
	    }
	
	    function getInertBodyElement_DOMParser(html) {
	      // We add this dummy element to ensure that the rest of the content is parsed as expected
	      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
	      html = '<remove></remove>' + html;
	      try {
	        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
	        body.firstChild.remove();
	        return body;
	      } catch (e) {
	        return undefined;
	      }
	    }
	
	    function getInertBodyElement_InertDocument(html) {
	      inertBodyElement.innerHTML = html;
	
	      // Support: IE 9-11 only
	      // strip custom-namespaced attributes on IE<=11
	      if (document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	
	      return inertBodyElement;
	    }
	  })(window, window.document);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	
	    var inertBodyElement = getInertBodyElement(html);
	    if (!inertBodyElement) return '';
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // trigger mXSS if it is going to happen by reading and writing the innerHTML
	      html = inertBodyElement.innerHTML;
	      inertBodyElement = getInertBodyElement(html);
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = getNonDescendant('nextSibling', node);
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = getNonDescendant('parentNode', node);
	            if (node === inertBodyElement) break;
	            nextNode = getNonDescendant('nextSibling', node);
	            if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = getNonDescendant('nextSibling', node);
	    }
	  }
	
	  function getNonDescendant(propName, node) {
	    // An element is clobbered if its `propName` property points to one of its descendants
	    var nextNode = node[propName];
	    if (nextNode && nodeContains.call(node, nextNode)) {
	      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
	    }
	    return nextNode;
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', [])
	  .provider('$sanitize', $SanitizeProvider)
	  .info({ angularVersion: '1.6.6' });
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _breedcluster = __webpack_require__(11);
	
	var _breedcluster2 = _interopRequireDefault(_breedcluster);
	
	var _translation = __webpack_require__(12);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	var _breedlist = __webpack_require__(13);
	
	var _breedlist2 = _interopRequireDefault(_breedlist);
	
	var _disorderdata = __webpack_require__(14);
	
	var _disorderdata2 = _interopRequireDefault(_disorderdata);
	
	var _entryid = __webpack_require__(15);
	
	var _entryid2 = _interopRequireDefault(_entryid);
	
	var _entry = __webpack_require__(17);
	
	var _entry2 = _interopRequireDefault(_entry);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _navigation = __webpack_require__(19);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _utility = __webpack_require__(20);
	
	var _utility2 = _interopRequireDefault(_utility);
	
	var _weightlist = __webpack_require__(21);
	
	var _weightlist2 = _interopRequireDefault(_weightlist);
	
	var _file = __webpack_require__(22);
	
	var _file2 = _interopRequireDefault(_file);
	
	var _chart = __webpack_require__(23);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var serviceModules = [_breedcluster2.default, _breedlist2.default, _disorderdata2.default, _entryid2.default, _entry2.default, _image2.default, _navigation2.default, _utility2.default, _translation2.default, _weightlist2.default, _file2.default, _chart2.default];
	
	exports.default = angular.module('mars.vet.dnareports.services', serviceModules).name;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('mars.vet.dnareports.services.breedcluster', []).factory('BreedClusterService', function (reportdata) {
	  'ngInject';
	
	  var getClusterCount = function getClusterCount() {
	    var breedData = [];
	    var clusterData = {};
	
	    angular.forEach(reportdata.resultString.resultCalls, function (value, key) {
	      if (!breedData.includes(value['breed'])) {
	        breedData.push(value['breed']);
	      }
	    });
	
	    angular.forEach(breedData, function (value, key) {
	      if (value.indexOf('^') > 1) {
	        var breedCluster = value.split('^');
	        if (clusterData[breedCluster[0]]) {
	          ++clusterData[breedCluster[0]];
	        } else {
	          clusterData[breedCluster[0]] = 1;
	        }
	      }
	    });
	    return clusterData;
	  };
	
	  return {
	    getBreedClusterCount: getClusterCount
	  };
	}).name;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translationFactory = translationFactory;
	function translationFactory(globalText) {
	    'ngInject';
	
	    return {
	        getTranslation: function getTranslation(text, upperCase) {
	            var translation = globalText[text];
	            return upperCase === true ? translation.toUpperCase() : translation;
	        }
	
	    };
	}
	
	exports.default = angular.module("mars.vet.pre.services.translation", ["ng"]).factory('TranslationService', translationFactory).name;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.breedListService = breedListService;
	function breedListService(EntryIDService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	
	    var getBreedList = function getBreedList() {
	        var breedList = {};
	        angular.forEach(resultString.resultCalls, function (value, key) {
	            var breedCluster = value['breed'].split("^");
	            var breed = breedCluster[0];
	
	            if (value['confFlag'] != 'X') {
	                if (breedList[breed]) {
	                    ++breedList[breed];
	                } else {
	                    breedList[breed] = 1;
	                }
	            } else {
	                if (breedList['Mixed Breed Groups']) {
	                    ++breedList['Mixed Breed Groups'];
	                } else {
	                    breedList['Mixed Breed Groups'] = 1;
	                }
	            }
	        });
	        return breedList;
	    };
	    return {
	        getBreedList: getBreedList,
	
	        getSortedBreedList: function getSortedBreedList() {
	            var breedList = [];
	            angular.forEach(getBreedList(), function (value, key) {
	                if (key != 'Mixed Breed Groups') {
	                    breedList.push({
	                        "breed": key,
	                        "count": value,
	                        "assetID": EntryIDService.getEntryID(key)
	                    });
	                }
	            });
	
	            breedList.sort(function (a, b) {
	                var count = b.count - a.count;
	                return count == 0 ? b.breed < a.breed : count;
	            });
	
	            if (getBreedList()['Mixed Breed Groups']) {
	                breedList.push({
	                    "breed": "Mixed Breed Groups",
	                    "count": getBreedList()['Mixed Breed Groups'],
	                    "assetID": EntryIDService.getEntryID("Mixed Breed Groups")
	                });
	            }
	            return breedList;
	        },
	
	        getTraceConfidence: function getTraceConfidence() {
	            var traceConfidence = false;
	
	            angular.forEach(resultString.resultCalls, function (value, key) {
	                var breedCluster = value['breed'].split("^");
	                var breed = breedCluster[0];
	
	                var confFlag = value['confFlag'];
	                if (confFlag == 'T') {
	                    traceConfidence = true;
	                }
	            });
	            return traceConfidence;
	        }
	    };
	}
	
	exports.default = angular.module('mars.vet.services.breedlist', ["ng"]).factory('BreedListService', breedListService).name;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('mars.vet.dnareports.services.disorders', []).factory('DisorderDataService', function (UtilityService, disorderData, reportdata) {
	  'ngInject';
	
	  var resultString = reportdata.resultString;
	  var petGender = reportdata.sampleDetails.petDetails.gender;
	  var sampleDetails = reportdata.sampleDetails;
	
	  var disorderDataList = {};
	  var diseaseCategory = [];
	
	  var atRiskData = [];
	  var carrierData = [];
	  var allClearData = [];
	  var noCallData = [];
	
	  var XLINKED = "X-linked";
	  var RECESSIVE = "autosomal recessive";
	  var DOMINANT = "autosomal dominant";
	  var MITO = "mitochondrial";
	
	  var isAtRisk = function isAtRisk(reportedDisorder) {
	    var disorder = disorderDataList[reportedDisorder.locusname];
	    var modeOfInheritance = disorder.modeOfInheritance;
	
	    if (modeOfInheritance == XLINKED) {
	      if (reportedDisorder.copies == 2) {
	        return true;
	      }
	
	      if (petGender == 'M' && reportedDisorder.copies == 1) {
	        return true;
	      }
	    } else if (modeOfInheritance == RECESSIVE) {
	      return reportedDisorder.copies == 2;
	    } else if (modeOfInheritance == MITO) {
	      return reportedDisorder.copies == 2;
	    } else if (modeOfInheritance == DOMINANT) {
	      return reportedDisorder.copies > 0;
	    }
	
	    return false;
	  };
	
	  var isCarrier = function isCarrier(reportedDisorder) {
	    var disorder = disorderDataList[reportedDisorder.locusname];
	    var modeOfInheritance = disorder.modeOfInheritance;
	
	    if (modeOfInheritance == XLINKED) {
	      return petGender == 'F' && reportedDisorder.copies == 1;
	    } else if (modeOfInheritance == RECESSIVE) {
	      return reportedDisorder.copies == 1;
	    }
	
	    return false;
	  };
	
	  var isAllClear = function isAllClear(reportedDisorder) {
	    return reportedDisorder.copies == 0;
	  };
	
	  var isNoCall = function isNoCall(reportedDisorder) {
	    var disorder = disorderDataList[reportedDisorder.locusname];
	    var modeOfInheritance = disorder.modeOfInheritance;
	
	    if (reportedDisorder.copies == -1) {
	      return true;
	    }
	
	    return false;
	  };
	
	  angular.forEach(disorderData, function (value, key) {
	    var fields = value.fields;
	    var oneCopyDesc = petGender == 'M' ? fields.oneCopyMale : fields.oneCopyFemale;
	    oneCopyDesc = oneCopyDesc.replaceAll('[name]', sampleDetails.petDetails.petName).replaceAll('[disease]', fields.diseaseName);
	
	    var twoCopyDesc = petGender == 'M' ? fields.twoCopyMale : fields.twoCopyFemale;
	    twoCopyDesc = twoCopyDesc.replaceAll('[name]', sampleDetails.petDetails.petName).replaceAll('[disease]', fields.diseaseName);
	
	    disorderDataList[fields.locusName] = {
	      'diseaseName': fields.diseaseName,
	      'entryId': value.sys.id,
	      'locusName': fields.locusName,
	      'enabled': fields.enabled,
	      'diseaseLongName': fields.diseaseLongName,
	      'diseaseCategory': fields.diseaseCategory,
	      'modeOfInheritance': fields.modeOfInheritance,
	      'vetandConsumerText': fields.vetandConsumerText,
	      'whatIsTheDisease': fields.whatIsTheDisease,
	      'clinicalDescription': fields.clinicalDescription,
	      'keySigns': fields.keySigns,
	      'onsetAge': fields.onsetAge,
	      'diseaseSeverity': fields.diseaseSeverity,
	      'likelihood': fields.likelihood,
	      'oneCopyDesc': oneCopyDesc,
	      'twoCopyDesc': twoCopyDesc
	    };
	  });
	
	  angular.forEach(resultString.disorders, function (value, key) {
	    var disorder = disorderDataList[value.locusname];
	    if (!disorder) {
	      console.log('no disorder');return;
	    }
	    if (disorder.enabled == false) {
	      return;
	    }
	
	    var modeOfInheritance = disorder.modeOfInheritance;
	
	    if (modeOfInheritance == XLINKED && petGender == 'M') {
	      if (value.copies == 1) {
	        value.copies = -1;
	      } else if (value.copies == 2) {
	        value.copies = 1;
	      }
	    } else if (modeOfInheritance == MITO && value.copies == 1) {
	      value.copies = -1;
	    }
	
	    if (value.copies == 1) {
	      disorder.displayDesc = disorder.oneCopyDesc;
	    } else if (value.copies == 2) {
	      disorder.displayDesc = disorder.twoCopyDesc;
	    }
	
	    var numberCopiesOneText = "[name] has one copy of this mutation.".replaceAll('[name]', sampleDetails.petDetails.petName);
	    var numberCopiesTwoText = "[name] has two copies of this mutation.".replaceAll('[name]', sampleDetails.petDetails.petName);
	    var numberCopiesSomeText = "[name] has copies of this mutation.".replaceAll('[name]', sampleDetails.petDetails.petName);
	
	    if (value.copies == 1) {
	      disorder.displayCopyText = numberCopiesOneText;
	    } else if (value.copies == 2) {
	
	      disorder.displayCopyText = numberCopiesTwoText;
	
	      if (modeOfInheritance == MITO) {
	        disorder.displayCopyText = numberCopiesSomeText;
	      }
	    }
	
	    if (isNoCall(value)) {
	      noCallData.push(disorder);return;
	    }
	    if (isAllClear(value)) {
	      allClearData.push(disorder);return;
	    }
	    if (isCarrier(value)) {
	      carrierData.push(disorder);return;
	    }
	    if (isAtRisk(value)) {
	      atRiskData.push(disorder);return;
	    }
	  });
	
	  return {
	    getAllClearData: function getAllClearData() {
	      return allClearData;
	    },
	    getAtRiskData: function getAtRiskData() {
	      return atRiskData;
	    },
	    getCarrierData: function getCarrierData() {
	      return carrierData;
	    },
	    getNoCallData: function getNoCallData() {
	      return [];
	    },
	    getDisorders: function getDisorders() {
	      return disorderDataList;
	    }
	  };
	}).name;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.entryidServiceFactory = entryidServiceFactory;
	var entriesmap = __webpack_require__(16).default;
	
	/*@ngInject*/
	function entryidServiceFactory() {
	
	  return {
	    getEntryID: function getEntryID(entry) {
	      return entriesmap[entry];
	    }
	  };
	}
	
	exports.default = angular.module('mars.vet.services.entryid', []).factory('EntryIDService', entryidServiceFactory).name;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  "Navbar": "2qYNA99b2EI2MYosu8wceO",
	  "HomePage": "44eCROQUqkUqOI0Wus0S2Q",
	  "Ancestry": "DDwY7OKPg48OEGEaCSYqy",
	  "Ancestry Tree": "13p1I2Ti8OACeCc6O4iW0i",
	  "Breed Tests": "nyiWblUhCo2G0o6qSis0s",
	  "Breeds": "3OiTX2kmm4ow2yCSW0MiSm",
	  "Mixed Breed Groups": "5KLZg84F5CMOwgIgYUMggq",
	  "Breed Group Mappings": "611bcIW9Dak4IICEKMI60M",
	  "Breeds Analyzed": "5bYOzV3LN6OeIUAm4ceCei",
	  "Certificate": "76I7hELemWiUkkuOakKiMi",
	  "Health": "3AbUuyPp4cqE0oCK0YIeOW",
	  "At Risk": "6YFZmcpRokGa2YIIUsOuU2",
	  "Carrier": "4jh6enNSZiIWyyQC6MwaWG",
	  "All Clear": "6Mh5EfBQPusiiw8qM8g6a0",
	  "No Call": "1LC9HdSIi0ocaaqis28MKy",
	  "Multidrug Sensitivity": "1lsPJLbeNaIwA8Wa0CsoCe",
	  "Traits": "5V6RjsO252AiKe0kAQc0YM",
	  "Exercise Induced Collapse": "6GTTMVG2T6YecEAKSiwMAg",
	  "Adult Weight": "6ruWyupC7YaE8MaEI888ym",
	  "Community": "2RhMmTw2FayUISWQIq0628",
	  "Learn More": "1LscpKCAisMGGCeGuSYEEE",
	  "Notes": "4L9cpL4sNqEAKIw2GKS0aG",
	  "The Science": "2hsJFF1pAgAOSyIwsiusYc",
	  "Our Technology": "1oS6m46Yfy8WEUs0wSe2Kc",
	  "Inheritance": "53eIuFYFZK8W4Cg6YYwAeO",
	  "FAQs": "7pByoRRQ76igSCsUYeYgwA",
	  "LearnMoreTraits": "1URIzGqqMQqQoW6KkyYyMG",
	  "Glossary": "5IUHxDSDT2ASMIwIGkgMis",
	  "Upgrade": "1AEABd1g7eiw4E4kQq0qq2",
	  "Affenpinscher": "vuoMIrUbniiwWWaqiUqKA",
	  "Afghan Hound": "4XsrnthDJeGgkMiIA4QAeY",
	  "Airedale Terrier": "yByiPUurqoEcYyYki0aAi",
	  "Akita": "6Df1f0zxBeAGKcq0u2W0Qy",
	  "Alaskan Klee Kai": "4MWRkckmowiyea0E6AOQCC",
	  "Alaskan Malamute": "6AwkVJMosE8YGEsaAom4sm",
	  "American English Coonhound": "1orPFNk22gaGYqYgUsaqK2",
	  "American Eskimo Dog": "1Ztji7RhWAWImUS688Mq00",
	  "American Foxhound": "6VRwrPSQfYgwmKyA0e2e8i",
	  "American Hairless Rat Terrier": "1lIz5RS66sikSgaqgYSmoo",
	  "American Staffordshire Terrier": "NwGtmgLSuq2aiWYIgiwwu",
	  "American Water Spaniel": "8VEqFlKx1u28UUQW2I0sO",
	  "Australian Cattle Dog": "72IReaOp1uAWcE6EAAKeE8",
	  "Argentine Dogo": "1X4KCeJJ5WQUScIiqsgAM0",
	  "Australian Kelpie": "44k9QFzM2k8KMcecCkWeM4",
	  "Australian Shepherd": "6AqTIuwKswWUsGesIAqyig",
	  "Australian Terrier": "e1ra8OEoJUwWY0y00iQOc",
	  "Anatolian Shepherd Dog": "401PSrDe9iCCQ8I6OWImcQ",
	  "Azawakh": "5JmeMLRLSEcGU2Okqoguks",
	  "Basenji": "7gAt4tlkJ22Y8sGiQowcQu",
	  "Basset Griffon Vendeen (Grand)": "4NYds6zBTi046Cy4WyAoG8",
	  "Basset Griffon Vendeen (Petit)": "2YIJTAfEOkKE0guYsOsGyo",
	  "Basset Hound": "41I88ViZDiSs6G6Eeey2ui",
	  "Barbet": "4TPFO1qqmAUwKsS222yMk4",
	  "Beagle": "10VGs1YohMYc24A6sWI2cm",
	  "Bearded Collie": "3oJfEsMLeMsaS6ygs8a84Q",
	  "Beauceron": "4dsIwTafCMW6MswSmiwEqY",
	  "Bedlington Terrier": "2S9y5axS8EeOIoAYSsOmmW",
	  "Belgian Sheepdog": "4NNU5byoowscouIEc0KKSC",
	  "Belgian Malinois": "4DfQx2jTQcmUEIMw4YymWG",
	  "Belgian Tervuren": "1XrPReoE8YoowgwmKkAgSC",
	  "Bergamasco": "67jXNmPx8QEamAE02miSea",
	  "Bernese Mountain Dog": "2JSoPsRZziO2ckea4eiWE6",
	  "Berger Picard": "3bc74WRcAw4UiQ0qSAeUyu",
	  "Bichon Frise": "49QCcf0NEcCse4ck2ga08A",
	  "Biewer Terrier": "5YmBgAdeGAUgee4UsAIMce",
	  "Black Russian Terrier": "rEf7WsOKsgaWe0yeISO0a",
	  "Bloodhound": "6jD1z4ib168a8SemKyQ22Q",
	  "Blue Tick Coonhound": "1z9Vy7a3i0gqWs66CakkKi",
	  "Boerboel": "1PL8ngVySswSqwIWoQSW8U",
	  "Bolognese": "2gIa7a6yIwYcoCGoImciSg",
	  "Border Collie": "49PRyJjaOcgiAcO4acM6qi",
	  "Border Terrier": "74Pa3jc4oMSmc6K8ywmeY4",
	  "Borzoi": "243GoDJQeksOSgIGQEsCY4",
	  "Boston Terrier": "2lysFdY8DCgeaQqoMOK8yo",
	  "Bouvier Des Flanders": "1OglMRofEAYCE8mGkAE4EI",
	  "Boxer": "3qIvqwBygwYKMm4OouaQSe",
	  "Boykin Spaniel": "r7yklhfuKGokoO0cQMkUE",
	  "Briard": "52yaCxwxL2G6EEskwwSS0I",
	  "Brittany": "7FEDu21X1Y4EsAqGKWwiIw",
	  "Brussels Griffon": "6yqFRl0c0gyoA0O0KkeoQa",
	  "Bull Terrier": "735Ctd9gxq4KcG46GI66WM",
	  "Bull Terrier (Miniature)": "IqSVExr4QuMIu2MkAGcEe",
	  "Bull Terrier (Standard)": "23ZOp4p9Lemi02iw0cmWCg",
	  "Bulldog": "24Tt2TyxqMY2UeouMwkEKO",
	  "Bulldog (American)": "5PJAsC1xjUmc2QimiAI2wC",
	  "Bulldog (Standard)": "3YimlIxmkMKmiu2uWAMS4Q",
	  "Bullmastiff": "140QW454UowM8I6UCkoYKE",
	  "Cairn Terrier": "1Yn50GLzsMmqAM4CgIk8O2",
	  "Canaan Dog": "5YDwE9kk6IQSOwumuQAKcm",
	  "Cane Corso": "4DtJ1hsfAIuS6GI0cW2K6I",
	  "Canadian Eskimo Dog": "5eUmE53pjGYQ6QI6SQMq4o",
	  "Cardigan Welsh Corgi": "1z3qRJ9s72oiYCoqIuWu8Q",
	  "Catahoula Leopard Dog": "1swRjukuRqgO4iEQo0UES2",
	  "Cavalier King Charles Spaniel": "6qWRNH4PtuUWwC6IsMMqGs",
	  "Cesky Terrier": "2ezyNHpd9aGIUcuwCYoOeC",
	  "Chesapeake Bay Retriever": "1QpzW3IVQYgiaiSgcMu0WO",
	  "Chihuahua": "45smeBj6RGoIwIWoUuQssq",
	  "Chinese Crested": "56sWwrwOc0YEeuCQU4EeKI",
	  "Chinese Shar-Pei": "76q9ONhvYAGESOq0m8OiYQ",
	  "Chinook": "4MhwsaSv16qKcIGMuQE4s0",
	  "Chow Chow": "7fMsgg4GxUSQq08iKqkKEQ",
	  "Cirneco del Etna": "2taPkq5UYoOwwiaOAquOug",
	  "Clumber Spaniel": "6wnunCWvZYumOSwoCYUcyq",
	  "Cocker Spaniel": "5j0GFpaUiIgUQSWkgMeisy",
	  "Collie": "1Jtb3GjwEwOCscMwKQyYYQ",
	  "Coonhound (Black and Tan)": "5uwbAUPqXmKIsaqgi6ESiK",
	  "Coton de Tulear": "4ZL5oEipJmwcMQCWWkES0k",
	  "Coyote": "2H37CjB9Ze08c8WkGamkei",
	  "Curly Coated Retriever": "2qaNTOOYwoOg2ea2WY6AEY",
	  "Dachshund": "5Vev6lWGYwsSiw6igWg0oQ",
	  "Dachshund (Miniature Shorthaired)": "6QbncgYdUWaU8OCGuk44CM",
	  "Dachshund (Longhaired)": "4TAmSK3MMMMmawgyYCCis4",
	  "Dachshund (Wirehaired)": "5ISZUrNw76aSu66M6Iw6so",
	  "Dachshund (Shorthaired)": "58UB3UPTAQosgWgAAeqWq6",
	  "Dachshund (Miniature Wirehaired)": "2TrKAsjnkQws4wUSeS8EOk",
	  "Dachshund (Miniature Longhaired)": "5bs3sPWDIQMCaGGOYyQeMg",
	  "Dalmatian": "1bPHZE2lDmmMOA6EEASeea",
	  "Dandie Dinmont Terrier": "44aJmRTKxGKYYWSWSKImUA",
	  "Dogue de Bordeaux": "4Dw3vcDuZWYekC2mKOa4Oe",
	  "Dobermann Pinscher": "2th08bv0xGYKK2EiOkG6oM",
	  "Dutch Shepherd Dog": "1yfkGkvbk8EqUaYmUqmCkW",
	  "English Cocker Spaniel": "2pdRrndFUsOImAmwqs0WSy",
	  "English Foxhound": "RhGqPjfyKWmCwGqOa0Gks",
	  "English Setter": "4yBuWokbuoiWMwyWwme6w2",
	  "English Springer Spaniel": "3BZizwYHPiI8OGYyEMg0m8",
	  "English Toy Spaniel": "23nUNgXKI8uwiEywwYE8Ie",
	  "English Toy Terrier (Black and Tan)": "2wKdAlXvqgwY8Yswi4cc0Q",
	  "Entlebucher Mountain Dog": "3877dwAlJ6W24EYqMckG60",
	  "Field Spaniel": "4mtsBFUyk8MEwmmYwCuyW2",
	  "Finnish Lapphund": "vpafr05XgWMWuo2souie8",
	  "Finnish Spitz": "UHnZmdXbuo4AaeUEgqCea",
	  "Flat Coated Retriever": "1TFLgC9kAIoAUeec6ScsQE",
	  "Fox Terrier (Smooth)": "60YRX58tWwoS2mW2CyCCsS",
	  "Fox Terrier (Toy)": "ygTinr3Uc0606IQwWSSEa",
	  "Fox Terrier (Wire)": "68xURzpTHOWoQ2M448o4Qy",
	  "French Bulldog": "2sOjaERCnmM8wYSYEEmEqC",
	  "German Pinscher": "57K1rQXMtqicAm6EsWKmUk",
	  "German Shepherd Dog": "1U3V8nV4Dq8mqK2cSc0swm",
	  "German Shorthaired Pointer": "7hwO4xM4xiqUaWeSOqWKeu",
	  "German Spitz": "5OU4ZVPPSEQy6gW8SGAqQO",
	  "German Wirehaired Pointer": "5xEW1mwr6wcc4uMakoqyqQ",
	  "Glen of Imaal Terrier": "2tmQJeuGDugIQo0SEuqmgy",
	  "Golden Retriever": "6yjOFrxveEEqCam4C4sGW4",
	  "Gordon Setter": "2Ag9bF8aXqWWcCOkqQSaww",
	  "Gray Wolf": "3ZKBhZAzDaIMwgyG2oWi42",
	  "Great Dane": "f7S7j1JKusiO8qamiocwW",
	  "Great Pyrenees": "9r5UQDINcksWMC6smqWui",
	  "Greater Swiss Mountain Dog": "JASpPUdiqOkQu8OkGUcWU",
	  "Greyhound": "2SelZTqxEsoyScoSOEOgeS",
	  "Harrier": "3tDfNftA4UeGEkaSCwaSmq",
	  "Havanese": "1TVqAxxrIkyKmkWumIaOae",
	  "Hovawart": "7Ixh48GTzaIUQQoUqSUy6y",
	  "Ibizan Hound": "KEVmGFp6SaUsy8i8CMUEg",
	  "Icelandic Sheepdog": "4Fslcez8KIKcY6G4sCYuKs",
	  "Irish Red and White Setter": "5x8MUyjelquyya4qMCIeiC",
	  "Irish Setter": "3BbmCUFkiIAUkgA6uC0Cqy",
	  "Irish Terrier": "rFKo96gX0kIKsmsgWQUIm",
	  "Irish Water Spaniel": "ATdX15QiVqw8oy48k8KCs",
	  "Irish Wolfhound": "Syxan6F5SwUIIw4Ui6ksm",
	  "Italian Greyhound": "4JHsWhr624wmMQEGIUiyQO",
	  "Italian Spinone": "6vH2iwcqPu4WEu8kGK06Am",
	  "Japanese Chin": "3pCHHuy2nKKi6WAom6s2Ac",
	  "Japanese Shiba Inu": "v9lTLR3PeSsyW6A2iE8UM",
	  "Japanese Spitz": "4jKMvRohQ4oqOm6mQU4kc0",
	  "Keeshond": "33jUb7cwbK8k6gWi6MS26C",
	  "Kerry Blue Terrier": "5mnNZUFKRUemMuIc6siA06",
	  "Komondor": "3QrED4clbOqMsS64AGMOk2",
	  "Koolie": "1XGLwoPxZmgYEOQUaoo8Eo",
	  "Kooikerhondje": "3uazCrIhu0IE4o8yEIAucs",
	  "Korean Jindo": "QQrn4mzyKaGsCQ8ae2kW",
	  "Kritikos Lagonikos": "6zpppBsZc4uScySEg0agOk",
	  "Kuvasz": "2yY0L2E5mYaCkCkWko8cm4",
	  "Labrador Retriever": "5qaI85odgIIuuSamGwsKye",
	  "Lagotto Romagnolo": "2BJpkq2rViUa6QMgcM6gKS",
	  "Lakeland Terrier": "718isAoCEEugqSO8uYa2CI",
	  "Lancashire Heeler": "5CMTSjGzaoKmUOW4sg8Oa2",
	  "Leonberger": "4j8pHQfiWsMyaEOswqOmsg",
	  "Lhasa Apso": "2uCH4EtPVqoW8WMCgmSAuq",
	  "Lowchen": "45L380jf6UogSMY8uO4Usi",
	  "Magyar Agar": "60WEOOZ0EocyAI2qAAIayg",
	  "Maltese": "75OWsbtKqkeGoe8kO4uawe",
	  "Manchester Terrier (Toy)": "6mo1hbyC6Auk8UKYiugamO",
	  "Manchester Terrier": "4FfxrzlD8IUAosgmAyUGm8",
	  "Maremma Sheepdog": "49cctIUk8oGwMIG6O8Okyu",
	  "Mastiff": "1okeO1CZlGAugAiKQUIgqc",
	  "McNab": "6ORWv5pOfuiuUOW4q4umAS",
	  "Mi-ki": "43i82mwMgwYqkUGASuUwm2",
	  "Miniature American Shepherd": "1mqeWGWu36gWW6GamcIuQQ",
	  "Miniature Pinscher": "4otA9nQaHYW6GoAC008yA2",
	  "Mudi": "6PdEuJv90QKiOQI6UgWki6",
	  "Munsterlander (Large)": "3Nis6tDJGEY0EkWCYckkY0",
	  "Munsterlander (Small)": "6i376YT4gEaKIogocuukqU",
	  "Murray River Curly Coated Retriever": "40zAuVhNiU2YOgimy2cuY2",
	  "Neapolitan Mastiff": "6yjvkGWRwIAAECw8WwuGOS",
	  "Newfoundland": "65NNOmGd1u2yqIsgmG4kiS",
	  "Norfolk Terrier": "66fmDfEYLYMym4YGQgko2",
	  "Norwegian Buhund": "3jkr0sNwWkEmikO2swYAyq",
	  "Norwegian Elkhound": "2KT86ndjhCQ2emGSs0aMeQ",
	  "Norwegian Lundehund": "3xZuP2gGnCUe8ycmwkE2au",
	  "Norwich Terrier": "2MbjP2vd5m8u0gS8c6Kogm",
	  "Nova Scotia Duck Tolling Retriever": "1wvvXuLp1aCeKcgS2yMkAA",
	  "Old English Sheepdog": "6PlsljIyjYsmmOmsAUmIqQ",
	  "Otterhound": "59EOUKvESQAAQkisG4AOi8",
	  "Papillon": "70PjeKmOliUSEguqkuMMsA",
	  "Parson Russell Terrier": "5EKnegpu3mSIeuSKWqi2cY",
	  "Pekingese": "4xg1WR3VRYuioWCGE8kge6",
	  "Pembroke Welsh Corgi": "7Ay9eU86gEemcSUOcWa2CI",
	  "Pharaoh Hound": "6IiF025Rraa2MIgC2mkYwO",
	  "Plott": "60jEbR5uY8AgGU4YaQqw2G",
	  "Podenco Canario": "4QNdcoCQVO6USQ2ACWUauy",
	  "Pointer": "7tpZjjGLWEiyoEeIGYyS4G",
	  "Pointing Griffon (Wire)": "4puK4QqrZKs8yoGuw4GIMW",
	  "Polish Greyhound": "1nSaTrgtiIkmAOC0o6OUCw",
	  "Polish Lowland Sheepdog": "jikZcq5jKSas2CKwsWiMW",
	  "Pomeranian": "2jTtjZxnbGIcAYuYyqymsu",
	  "Poodle": "3mfCT4SjwQugmy8GcSkyCo",
	  "Poodle (Medium)": "56dzkHoSa4KOUy6oaQg2yK",
	  "Poodle (Miniature)": "hQC92eLjVuakqaK6uqgsK",
	  "Poodle (Standard)": "5iuStNczzqqUgwSA8qGyQs",
	  "Poodle (Toy)": "3JftLswCd26wMgOqky4ISq",
	  "Portuguese Podengo Medio": "4b5yuyuGV2e02Yqa2yuW8e",
	  "Portuguese Podengo Pequenos": "mQWdEzOhfUIsiec8eUQyi",
	  "Portuguese Water Dog": "33VvIoNfWgwIEES6w6q2sS",
	  "Presa Canario": "62LJyY7kuQs0cYAw2gEYwC",
	  "Pug": "6Gk0w42dkA6eGmSG4KYmOA",
	  "Puli": "6aTFaEmYMMwq4Owas0cqCo",
	  "Pumi": "4kEnS0J6RyaEiGSggA44QG",
	  "Pyrenean Shepherd": "4ikWnFRJQI00m2CcqaOkO",
	  "Rat Terrier": "3BCzLV9KoUeyuE4SO8sQeG",
	  "Redbone Coonhound": "1pbphwZPhOAS4C28e2W42S",
	  "Rhodesian Ridgeback": "2WK0FCoDFCyG6qIOyMOaa8",
	  "Rottweiler": "3GRNBl1t1C4yqio0AWocO4",
	  "Russian Tsvetnaya Bolonka": "5bu1vzDVXaoyGs8IAS6GWo",
	  "Russell Terrier": "7IfvQxuZJ6WuossCKoS86y",
	  "Saint Bernard": "6noPg01MpUSWiqq0WiQO0g",
	  "Saluki": "4DumoeHXBeKsGe4ymwS0YO",
	  "Samoyed": "6CzfJVotSE2QQ226k2gqKY",
	  "Schipperke": "2awxWYKEbeieECm0WyaSsO",
	  "Schnauzer (Giant)": "1jJUcI6m5A4w6eGqguWykE",
	  "Schnauzer (Miniature)": "1CXtgbTH9e2k4g8Qysswqm",
	  "Schnauzer (Standard)": "2WGyp1d1mMo4k6SsCEAscM",
	  "Scottish Deerhound": "6GyxBvry8gO80U24i4QkAK",
	  "Scottish Terrier": "6yP2wUL7xuOu22UEaSKoIq",
	  "Sealyham Terrier": "4DYnCtouqI0caUw24wKiOI",
	  "Shetland Sheepdog": "3civWHLOmQgwowUEk44YMw",
	  "Shih Tzu": "1FNyNfNmiA26WEkkAcSKay",
	  "Siberian Husky": "4GlgNd0EWIg8ocQgKAggO6",
	  "Silky Terrier": "3PcTxecUdq4iaWyEGU0ass",
	  "Skye Terrier": "2d7RxqdkyQMOCwMIKyyCqW",
	  "Sloughi": "4irJvjR8CccwiMsis6U6AI",
	  "Soft Coated Wheaten Terrier": "20FUcsUkugaASgwKq8E4OK",
	  "Spanish Greyhound": "4UPHAcuypOQ086W2A0KyAK",
	  "Spanish Water Dog": "3jzbLFa6pW0yAGcE2wO2A2",
	  "Staffordshire Bull Terrier": "2VdaTPnMgUC4m8qMk6UiOm",
	  "Sussex Spaniel": "2v8ih3tkJ66EuGOk8MYI0Y",
	  "Swedish Vallhund": "7wY10c5EJimQGMi8Uu0Ima",
	  "Taigan": "5YijL3sMVisWAeucO6m6gI",
	  "Tibetan Mastiff": "2VOv0HFKsEs8CkcUs0WAUy",
	  "Tibetan Spaniel": "6kIxSCwRgca8E0Kkuc02Uu",
	  "Tibetan Terrier": "4oGrl7kJqwwwqYk6mQisIO",
	  "Treeing Walker Coonhound": "2ka8FZSCTKMy4wm8SUUWoc",
	  "Vizsla": "6kurbAoCAgOgwUKckGgOis",
	  "Weimaraner": "2NZduNuFtueO0AaAosK0mE",
	  "Welsh Springer Spaniel": "5KNRq0lYpUIkU02S6EqIwo",
	  "Welsh Terrier": "3snSlE7yPCqaoKoQEqSi0C",
	  "West Highland White Terrier": "l0y8sHlZmKs4SyaqkqiI6",
	  "Whippet": "39wsB0xkTSyggiUgOcUwuW",
	  "White Swiss Shepherd": "57rDvS5Oicc2gI2u2kKwGq",
	  "Wirehaired Vizsla": "4iUFdMCZ7iigEOK4uk2UYs",
	  "Xoloitzcuintli": "47U4hMPAbuU4EkOQ4IAIWY",
	  "Yorkshire Terrier": "2CxvDMyr3qwOa8kKSQCyoY"
	};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function entryServiceFactory($http, $q, config, reportdata) {
	    'ngInject';
	
	    var contentful = config.contentful;
	    var locale = reportdata.locale;
	
	    return {
	        getEntry: function getEntry(assetID) {
	            return $http.get(contentful.url + contentful.spaceid + '/entries/' + assetID + '/?access_token=' + contentful.access_token + '&locale=' + locale, { cache: true }).then(function (response) {
	                if (_typeof(response.data) === 'object') {
	                    return response.data;
	                } else {
	                    console.log("TextService invalid response: assetID: " + assetID);
	                    return $q.reject(response.data);
	                }
	            }, function (response) {
	                console.log("EntryService error: assetID: " + assetID);
	                return $q.reject(response.data);
	            });
	        }
	    };
	}
	
	exports.default = angular.module('mars.vet.services.entry', ["ng"]).factory("EntryService", entryServiceFactory).name;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.services.image", ["ng"]).factory('ImageService', function ($http, config) {
	    'ngInject';
	
	    var assetIDUrlCache = {};
	
	    var contentful = config.contentful;
	
	    return {
	        getImageUrl: function getImageUrl(assetID) {
	            if (assetIDUrlCache[assetID] === undefined) {
	                var promise = $http.get(contentful.url + contentful.spaceid + '/assets/' + assetID + '?access_token=' + contentful.access_token, {
	                    cache: true
	                });
	                assetIDUrlCache[assetID] = promise;
	                return promise;
	            } else {
	                return assetIDUrlCache[assetID];
	            }
	        }
	    };
	}).name;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function navigationServiceFactory($rootScope, $location, BreedListService, EntryIDService, TranslationService, UtilityService, DisorderDataService, reportdata) {
	
	    'ngInject';
	
	    var navList = [];
	    var resultString = reportdata.resultString;
	
	    var atRiskData = DisorderDataService.getAtRiskData();
	    var carrierData = DisorderDataService.getCarrierData();
	    var noCallData = DisorderDataService.getNoCallData();
	    var allClearData = DisorderDataService.getAllClearData();
	
	    var buildNavigationList = function buildNavigationList() {
	
	        navList.push({
	            "url": "/",
	            "text": "Home"
	        });
	        navList.push({
	            "url": "/ancestry/" + EntryIDService.getEntryID("Ancestry"),
	            "text": "Start: Ancestry"
	        });
	        navList.push({
	            "url": "/ancestrytree/" + EntryIDService.getEntryID("Ancestry Tree"),
	            "text": "Next: Ancestry Tree"
	        });
	
	        if (resultString.resultPbDd && resultString.resultPbDd.length > 0) {
	            navList.push({
	                "url": "/breedtests/" + EntryIDService.getEntryID("Breed Tests"),
	                "text": "Next: Breed Tests"
	            });
	        }
	
	        var breedList = BreedListService.getSortedBreedList();
	
	        for (var i = 0; i < breedList.length; ++i) {
	            if (breedList[i]['breed'] == 'Mixed Breed Groups') {
	                navList.push({
	                    "url": "/mixedbreedgroups/" + EntryIDService.getEntryID("Mixed Breed Groups"),
	                    "text": "Next: Mixed Breed Groups"
	                });
	            } else if (breedList[i]['count'] > 0) {
	                navList.push({
	                    "url": "/breed/" + EntryIDService.getEntryID(breedList[i]['breed']),
	                    "text": "Next: Breed"
	                });
	            }
	        }
	
	        var productVersion = UtilityService.getProductVersion();
	
	        if (UtilityService.getVersionFeature('Breeds Analyzed')) {
	            navList.push({
	                "url": "/breedsanalyzed/" + EntryIDService.getEntryID("Breeds Analyzed"),
	                "text": "Next: Breeds Analyzed"
	            });
	        }
	
	        navList.push({
	            "url": "/certificate/" + EntryIDService.getEntryID("Certificate"),
	            "text": "Next: Certificate"
	        });
	        navList.push({
	            "url": "/health/" + EntryIDService.getEntryID("Health"),
	            "text": "Next: Health"
	        });
	        if (UtilityService.getVersionFeature('WisdomHealth')) {
	            if (atRiskData.length > 0) {
	                navList.push({
	                    "url": "/atrisk/" + EntryIDService.getEntryID('At Risk'),
	                    "text": "Next: At Risk"
	                });
	            }
	
	            if (carrierData.length > 0) {
	                navList.push({
	                    "url": "/carrier/" + EntryIDService.getEntryID('Carrier'),
	                    "text": "Next: Carrier"
	                });
	            }
	            if (allClearData.length > 0) {
	                navList.push({
	                    "url": "/allclear/" + EntryIDService.getEntryID('All Clear'),
	                    "text": "Next: All Clear"
	                });
	            }
	            if (noCallData.length > 0) {
	                navList.push({
	                    "url": "/nocall/" + EntryIDService.getEntryID('No Call'),
	                    "text": "Next: No Call"
	                });
	            }
	        }
	        if (UtilityService.getVersionFeature('MDR1')) {
	            navList.push({
	                "url": "/multidrugsensitivity/" + EntryIDService.getEntryID("Multidrug Sensitivity"),
	                "text": "Next: Multidrug Sensitivity"
	            });
	        }
	        if (UtilityService.getVersionFeature('EIC')) {
	            navList.push({
	                "url": "/eic/" + EntryIDService.getEntryID("Exercise Induced Collapse"),
	                "text": "Next: Exercise Induced Collapse"
	            });
	        }
	        navList.push({
	            "url": "/adultweight/" + EntryIDService.getEntryID("Adult Weight"),
	            "text": "Next: Adult Weight"
	        });
	        if (UtilityService.getVersionFeature('Traits')) {
	            navList.push({
	                "url": "/traits/" + EntryIDService.getEntryID("Traits"),
	                "text": "Next: Traits"
	            });
	        }
	        navList.push({
	            "url": "/notes/" + EntryIDService.getEntryID("Notes"),
	            "text": "Next: Notes"
	        });
	
	        return navList;
	    };
	
	    var getNext = function getNext(location) {
	
	        for (var i = 0; i < navList.length; ++i) {
	            if (location == navList[i]['url'] && i < navList.length - 1) {
	                return navList[i + 1];
	            }
	        }
	        return {
	            "url": "",
	            "text": ""
	        };
	    };
	
	    var getPrev = function getPrev(location) {
	
	        for (var i = navList.length - 1; i >= 0; --i) {
	            if (location == navList[i]['url'] && i > 0) {
	
	                return navList[i - 1];
	            }
	        }
	
	        return {
	            "url": "",
	            "text": ""
	        };
	    };
	
	    return {
	        getPrev: getPrev,
	        getNext: getNext,
	        buildNavigationList: buildNavigationList,
	        setNavigationUrls: function setNavigationUrls() {
	
	            if (navList.length == 0) {
	                navList = buildNavigationList();
	            }
	            var location = $location.url();
	            var next = getNext(location);
	            $rootScope.forwardUrl = next['url'].length > 0 ? next['url'].substring(1) : "";
	            $rootScope.forwardText = next['url'].length > 0 ? TranslationService.getTranslation(next['text']) : "";
	
	            var prev = getPrev(location);
	            $rootScope.backwardUrl = prev['url'].length > 0 ? prev['url'].substring(1) : "";
	            $rootScope.backwardText = prev['url'].length > 0 ? TranslationService.getTranslation("Back") : "";
	        }
	    };
	}
	
	exports.default = angular.module('mars.vet.services.navigation', []).factory('NavigationService', navigationServiceFactory).name;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.utilityServiceFactory = utilityServiceFactory;
	function utilityServiceFactory(reportdata, config) {
	
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	    var productVersion = sampleDetails.productVersion == '' ? '2.0' : sampleDetails.productVersion;
	    $(document).ready(function () {
	        $('[data-toggle="tooltip"]').tooltip();
	    });
	
	    String.prototype.replaceAll = function (s, r) {
	        return this.split(s).join(r);
	    };
	
	    return {
	        getVersionFeature: function getVersionFeature(feature) {
	
	            var featureEnabled = true;
	            var traits = resultString.traits;
	
	            if (feature == "Traits") {
	                if (traits === undefined || traits.length == 0) {
	                    featureEnabled = false;
	                }
	            }
	
	            return featureEnabled && config.productfeatures[productVersion].indexOf(feature) >= 0;
	        },
	        getProductVersion: function getProductVersion() {
	
	            return productVersion;
	        },
	        formatDate: function formatDate(date) {
	            var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	            var formatedDate = date.substring(0, 10);
	            var splitdate = formatedDate.split("-");
	
	            var your_date = new Date(splitdate[0], splitdate[1] - 1, splitdate[2]);
	            return monthNames[your_date.getMonth()] + ' ' + your_date.getDate() + ', ' + your_date.getFullYear();
	        },
	        fbs_click: function fbs_click() {
	            var myImage = document.getElementById('certificate');
	            var src = myImage.src;
	            window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(src) + '&t=' + encodeURIComponent(src) + '&title=Check out my Wisdom Panel Doggie DNA results! #WisdomPanelAmbassadors', 'sharer', 'toolbar=0,status=0,width=626,height=436');
	            return false;
	        },
	        instagram_click: function instagram_click() {
	            var myImage = document.getElementById('certificate');
	            var src = myImage.src;
	            window.open("https://instagram.com/wisdompanel?url=" + escape(src) + "&text=" + document.title + '&media=' + encodeURIComponent(src), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
	            return false;
	        },
	        twitter_click: function twitter_click() {
	            var myImage = document.getElementById('certificate');
	            var src = myImage.src;
	            window.open('https://twitter.com/intent/tweet?url=' + src, "status = 1, toolbar=0,status=0,width=626,height=436");
	            return false;
	        },
	        pinterest_click: function pinterest_click() {
	            var myImage = document.getElementById('certificate');
	            var src = myImage.src;
	            window.open('http://pinterest.com/pin/create/button/?url=' + encodeURIComponent(src) + '&media=' + encodeURIComponent(src) + '&t=' + encodeURIComponent(src), "status = 1, toolbar=0,status=0,width=626,height=436");
	            return false;
	        },
	        printCertificate: function printCertificate() {
	            var ua = window.navigator.userAgent;
	            var msie = ua.indexOf("MSIE ");
	            var printCertificatePath = "/staticresources/dnareports/images/" + resultString.sampleID + "/certificate.png";
	            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
	                    var myWindow = window.open('', '', 'width=100%,height=100%');
	                    myWindow.document.write('<img src="' + printCertificatePath + '" height="100%" width="100%"/>');
	                    myWindow.document.close();
	                    myWindow.focus();
	                    myWindow.print();
	                    myWindow.close();
	                } else {
	                var win = window.open('');
	                win.document.write('<img src="' + printCertificatePath + '" onload="window.print();window.close()" height="150%" width="100%"/>');
	                win.focus();
	            }
	        }
	    };
	}
	
	exports.default = angular.module('mars.vet.services.utility', []).factory('UtilityService', utilityServiceFactory).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.services.weightlist", []).factory('WeightListService', function (reportdata) {
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    return {
	        getWeightList: function getWeightList($scope) {
	            var petDetails = sampleDetails.petDetails;
	
	            var weightList = [];
	            var displayMsg;
	            var weightArray = [];
	            var messageArray = [];
	            var testName = sampleDetails.testName;
	            var resultSize = resultString.resultSize;
	
	            if (petDetails.gender == 'M') {
	                if (sampleDetails.petDetails.neuter == 'Y') {
	                    displayMsg = "male/neutered";
	                    weightArray.push("neutered");
	                    messageArray.push(displayMsg);
	                } else if (sampleDetails.petDetails.neuter == 'N') {
	                    displayMsg = "male/intact";
	                    weightArray.push("male");
	                    messageArray.push(displayMsg);
	                } else {
	                    displayMsg = "if male/neutered";
	                    weightArray.push("neutered");
	                    messageArray.push("Male/Neutered");
	                    weightArray.push("male");
	                    messageArray.push("Male/Intact");
	                }
	            } else if (petDetails.gender == 'F') {
	                if (sampleDetails.petDetails.neuter == 'Y') {
	                    displayMsg = "female/spayed";
	                    weightArray.push("spayed");
	                    messageArray.push(displayMsg);
	                } else if (sampleDetails.petDetails.neuter == 'N') {
	                    displayMsg = "female/intact";
	                    weightArray.push("female");
	                    messageArray.push(displayMsg);
	                } else {
	                    displayMsg = "if female/spayed";
	                    weightArray.push("spayed");
	                    messageArray.push("Female/Spayed");
	                    weightArray.push("female");
	                    messageArray.push("Female/Intact");
	                }
	            } else {
	                displayMsg = "if male/neutred/female/spayed";
	                weightArray.push("male");
	                weightArray.push("neutered");
	                weightArray.push("female");
	                weightArray.push("spayed");
	            }
	
	            var predSize = 0;
	            var minSize = 0;
	            var maxSize = 0;
	
	            for (var k = 0; k <= weightArray.length; k++) {
	                angular.forEach(resultSize, function (value, key) {
	                    predSize = value['pred_size'];
	                    minSize = value['min_size'];
	                    maxSize = value['max_size'];
	
	                    if (value['type_size'] == weightArray[k]) {
	                        if (testName == 'WisdomUK_IN') {
	                            predSize = Math.round(predSize * 0.45359237);
	                            minSize = Math.round(minSize * 0.45359237);
	                            maxSize = Math.round(maxSize * 0.45359237);
	                        }
	                        weightList.push({
	                            "Message": displayMsg,
	                            "Type": value['type_size'],
	                            "PredSize": predSize,
	                            "MinSize": minSize,
	                            "MaxSize": maxSize
	                        });
	                    }
	                });
	            }
	            return weightList;
	        }
	    };
	}).name;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function fileServiceFactory() {
	
	    return {
	        getFilePath: function getFilePath(sampleID) {
	
	            var filePath = "";
	
	            if (!(sampleID === null) && !(sampleID === undefined) && sampleID.length > 5) {
	
	                filePath = sampleID.substring(0, 5);
	
	                if (sampleID.length < 9) {
	                    filePath += "/" + sampleID.substring(5, sampleID.length) + "/";
	                } else {
	                    filePath += "/" + sampleID.substring(5, 9) + "/";
	                }
	                filePath += sampleID + "/";
	            }
	            return filePath;
	        }
	    };
	}
	
	exports.default = angular.module("mars.vet.dnareports.services.file", ["ng"]).factory("FileService", fileServiceFactory).name;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module('mars.vet.dnareports.services.chart', []).factory('ChartService', function () {
	    'ngInject';
	
	    return {
	        printRow: function printRow(row) {
	            angular.forEach(row, function (column, key) {
	                angular.forEach(column, function (value, key) {
	                    console.log("column value: " + value['breed'] + ' ' + value['confFlag'] + ' ' + value['confPC']);
	                });
	            });
	        },
	        getDisplayName: function getDisplayName(breedList) {
	            var displayName = '';
	
	            var mixed = false;
	            angular.forEach(breedList, function (value, key) {
	                if (value['displayName'] != 'Mixed Breed') {
	                    displayName += key > 0 ? ' / ' + value['displayName'] : value['displayName'];
	                } else {
	                    mixed = true;
	                }
	            });
	            if (mixed === true && breedList.length == 1) {
	                displayName = 'Mixed Breed';
	            } else if (mixed === true) {
	                displayName += ' Mix';
	            } else if (breedList.length > 1) {
	                displayName += ' Cross';
	            }
	
	            if (displayName.indexOf('/') == 1) {
	                displayName = displayName.substring(2, displayName.length);
	            }
	            return displayName;
	        }
	    };
	}).name;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(25);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _adultweight = __webpack_require__(27);
	
	var _adultweight2 = _interopRequireDefault(_adultweight);
	
	var _breed = __webpack_require__(28);
	
	var _breed2 = _interopRequireDefault(_breed);
	
	var _breedlist = __webpack_require__(29);
	
	var _breedlist2 = _interopRequireDefault(_breedlist);
	
	var _breedsanalyzed = __webpack_require__(30);
	
	var _breedsanalyzed2 = _interopRequireDefault(_breedsanalyzed);
	
	var _breedscertificate = __webpack_require__(31);
	
	var _breedscertificate2 = _interopRequireDefault(_breedscertificate);
	
	var _breedtests = __webpack_require__(32);
	
	var _breedtests2 = _interopRequireDefault(_breedtests);
	
	var _carrier = __webpack_require__(33);
	
	var _carrier2 = _interopRequireDefault(_carrier);
	
	var _nocall = __webpack_require__(34);
	
	var _nocall2 = _interopRequireDefault(_nocall);
	
	var _allclear = __webpack_require__(35);
	
	var _allclear2 = _interopRequireDefault(_allclear);
	
	var _atrisk = __webpack_require__(38);
	
	var _atrisk2 = _interopRequireDefault(_atrisk);
	
	var _eic = __webpack_require__(39);
	
	var _eic2 = _interopRequireDefault(_eic);
	
	var _exceptionletter = __webpack_require__(40);
	
	var _exceptionletter2 = _interopRequireDefault(_exceptionletter);
	
	var _faq = __webpack_require__(41);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _glossary = __webpack_require__(42);
	
	var _glossary2 = _interopRequireDefault(_glossary);
	
	var _health = __webpack_require__(43);
	
	var _health2 = _interopRequireDefault(_health);
	
	var _homepage = __webpack_require__(44);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	var _inheritance = __webpack_require__(45);
	
	var _inheritance2 = _interopRequireDefault(_inheritance);
	
	var _learnmore = __webpack_require__(46);
	
	var _learnmore2 = _interopRequireDefault(_learnmore);
	
	var _mixedcomponent = __webpack_require__(47);
	
	var _mixedcomponent2 = _interopRequireDefault(_mixedcomponent);
	
	var _multidrugsensitivity = __webpack_require__(48);
	
	var _multidrugsensitivity2 = _interopRequireDefault(_multidrugsensitivity);
	
	var _notes = __webpack_require__(49);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	var _pbddletter = __webpack_require__(50);
	
	var _pbddletter2 = _interopRequireDefault(_pbddletter);
	
	var _percentage = __webpack_require__(51);
	
	var _percentage2 = _interopRequireDefault(_percentage);
	
	var _print = __webpack_require__(52);
	
	var _print2 = _interopRequireDefault(_print);
	
	var _printbreed = __webpack_require__(53);
	
	var _printbreed2 = _interopRequireDefault(_printbreed);
	
	var _technology = __webpack_require__(54);
	
	var _technology2 = _interopRequireDefault(_technology);
	
	var _thescience = __webpack_require__(55);
	
	var _thescience2 = _interopRequireDefault(_thescience);
	
	var _traits = __webpack_require__(56);
	
	var _traits2 = _interopRequireDefault(_traits);
	
	var _ancestry = __webpack_require__(57);
	
	var _ancestry2 = _interopRequireDefault(_ancestry);
	
	var _learnmoretraits = __webpack_require__(58);
	
	var _learnmoretraits2 = _interopRequireDefault(_learnmoretraits);
	
	var _upgrademodal = __webpack_require__(59);
	
	var _upgrademodal2 = _interopRequireDefault(_upgrademodal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var controllers = [_navbar2.default, _adultweight2.default, _allclear2.default, _atrisk2.default, _breed2.default, _breedlist2.default, _breedsanalyzed2.default, _breedscertificate2.default, _breedtests2.default, _carrier2.default, _eic2.default, _exceptionletter2.default, _faq2.default, _glossary2.default, _health2.default, _homepage2.default, _inheritance2.default, _learnmore2.default, _mixedcomponent2.default, _multidrugsensitivity2.default, _notes2.default, _pbddletter2.default, _percentage2.default, _print2.default, _printbreed2.default, _technology2.default, _thescience2.default, _traits2.default, _ancestry2.default, _learnmoretraits2.default, _nocall2.default, _upgrademodal2.default];
	
	exports.default = angular.module("mars.vet.dnareports.controllers", controllers);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.navbarController = navbarController;
	function navbarController($rootScope, $scope, $window, $uibModal, BreedListService, DisorderDataService, EntryIDService, NavigationService, ImageService, TranslationService, UtilityService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	    var reportDetails = reportdata.reportDetails;
	    var lastSlash = window.location.pathname.lastIndexOf("/");
	
	    var token = window.location.pathname.substring(lastSlash + 1, window.location.pathname.length);
	
	    ImageService.getImageUrl('2wmltkOoi4woMqyqeC246q').then(function (response) {
	        $scope.downloadImageUrl = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl('hF9D8w0GkwekaaGiWiUoa').then(function (response) {
	        $scope.wisdomPanelLogoUrl = response.data.fields.file.url;
	    });
	
	    $scope.open = function () {
	        var modalInstance = $uibModal.open({
	            template: __webpack_require__(26),
	            controller: 'UpgradeModalController'
	        });
	    };
	
	    $scope.reportToken = token;
	    $scope.translation = TranslationService.getTranslation;
	    $scope.getVersionFeature = UtilityService.getVersionFeature;
	    $scope.productVersion = UtilityService.getProductVersion();
	    $scope.breedList = BreedListService.getSortedBreedList();
	    $scope.ancestryEntryID = EntryIDService.getEntryID('Ancestry');
	    $scope.ancestrytreeEntryID = EntryIDService.getEntryID('Ancestry Tree');
	    $scope.breedtestsEntryID = EntryIDService.getEntryID('Breed Tests');
	    $scope.breedsEntryID = EntryIDService.getEntryID('Breeds');
	    $scope.breedsanalyzedEntryID = EntryIDService.getEntryID('Breeds Analyzed');
	    $scope.certificateEntryID = EntryIDService.getEntryID('Certificate');
	    $scope.healthEntryID = EntryIDService.getEntryID('Health');
	    $scope.multidrugsensitivityEntryID = EntryIDService.getEntryID('Multidrug Sensitivity');
	    $scope.traitsEntryID = EntryIDService.getEntryID('Traits');
	    $scope.eicEntryID = EntryIDService.getEntryID('Exercise Induced Collapse');
	    $scope.adultweightEntryID = EntryIDService.getEntryID('Adult Weight');
	    $scope.atRiskEntryID = EntryIDService.getEntryID('At Risk');
	    $scope.carrierEntryID = EntryIDService.getEntryID('Carrier');
	    $scope.allClearEntryID = EntryIDService.getEntryID('All Clear');
	    $scope.noCallEntryID = EntryIDService.getEntryID('No Call');
	    $scope.communityEntryID = EntryIDService.getEntryID('Community');
	    $scope.learnMoreEntryID = EntryIDService.getEntryID('Learn More');
	    $scope.theScienceEntryID = EntryIDService.getEntryID('The Science');
	    $scope.faqsEntryID = EntryIDService.getEntryID('FAQs');
	    $scope.ourTechnologyEntryID = EntryIDService.getEntryID('Our Technology');
	    $scope.inheritanceEntryID = EntryIDService.getEntryID('Inheritance');
	    $scope.learnmoreTraitsEntryID = EntryIDService.getEntryID('LearnMoreTraits');
	    $scope.glossaryEntryID = EntryIDService.getEntryID('Glossary');
	    $scope.notesEntryID = EntryIDService.getEntryID('Notes');
	    $scope.breedTests = resultString.resultPbDd !== undefined && resultString.resultPbDd.length > 0;
	    $scope.sampleID = resultString.sampleID;
	    $scope.allowUpgrade = sampleDetails.upgrade;
	    console.log('allowUpgrade: ' + $scope.allowUpgrade + ' ' + sampleDetails.upgrade);
	
	    $scope.atRiskData = DisorderDataService.getAtRiskData();
	    $scope.carrierData = DisorderDataService.getCarrierData();
	    $scope.noCallData = DisorderDataService.getNoCallData();
	    $scope.allClearData = DisorderDataService.getAllClearData();
	
	    var notifyCount = 0;
	    var genHealthCount = 0;
	    var letterCheck = false;
	    var genHealthCheck = false;
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var cookies = decodedCookie.split(';');
	
	    for (var i = 0; i < cookies.length; i++) {
	        var cookieAttr = cookies[i];
	        if (cookieAttr.indexOf('letterCheck') > -1) {
	            letterCheck = cookieAttr.substr(cookieAttr.indexOf("=") + 1);
	        }
	        if (cookieAttr.indexOf('genHealthCheck') > -1) {
	            genHealthCheck = cookieAttr.substr(cookieAttr.indexOf("=") + 1);
	        }
	    }
	
	    if (!letterCheck) {
	        var letterCount = 0;
	        var resultPbDdBreed = resultString.resultPbDdBreed;
	        if (resultPbDdBreed !== undefined && resultPbDdBreed !== null && resultPbDdBreed.length > 0) {
	            letterCount = letterCount + 1;
	        }
	        if (resultString.event[0] !== null && resultString.event[0] !== undefined && resultString.event[0]['letterflag'] != null && resultString.event[0]['letterflag'] != 'undefined') {
	            letterCount = letterCount + 1;
	        }
	        notifyCount = letterCount;
	        document.cookie = "letterCheck=true";
	    }
	
	    if (!genHealthCheck) {
	        genHealthCount = $scope.atRiskData.length + $scope.carrierData.length;
	        document.cookie = "genHealthCheck=true";
	    }
	
	    var base64EncodedToken = window.btoa('03102017\\' + $scope.sampleID + '\\' + $scope.sampleID + '-wo').replaceAll('=', '');
	
	    $scope.downloadReportUrl = reportdata.pdfdownloadurl + '/' + base64EncodedToken + '.pdf';
	
	    $scope.notifyCount = notifyCount;
	    $scope.genHealthCount = genHealthCount;
	
	    $rootScope.$broadcast('checkGenHealthCount', 0);
	
	    NavigationService.setNavigationUrls();
	
	    $scope.$on('checkGenHealthCount', function (event, actualValue) {
	        $scope.genHealthCount = $scope.genHealthCount - actualValue;
	    });
	
	    $scope.$on('checkNotifyCount', function (event, actualValue) {
	        $scope.notifyCount = $scope.notifyCount - actualValue;
	    });
	
	    ImageService.getImageUrl('4gvF3KnZfqOUoYMQWCcwka').then(function (response) {
	        $scope.fbIcon = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl('5GJEkOWWR2wu4e8COuWiQE').then(function (response) {
	        $scope.twIcon = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl('4dhYsZ1sqco0iqiUcsYC6I').then(function (response) {
	        $scope.youtubeIcon = response.data.fields.file.url;
	    });
	
	    ImageService.getImageUrl('6lKwO09ax2a0QmWSQ4ocKk').then(function (response) {
	        $scope.igIcon = response.data.fields.file.url;
	    });
	
	    ImageService.getImageUrl('2OK1sW2blScw0UG2kgiWAo').then(function (response) {
	        $scope.marsVetLogo = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl('32aMK5VSfKCE08C4oSUyOQ').then(function (response) {
	        $scope.navForwardButton = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl('1BcpcMv0FK6M0QG0Mg4QO').then(function (response) {
	        $scope.navBackButton = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl('4gEGHgNJbigiuok8aESeiq').then(function (response) {
	        $scope.navNextButton = response.data.fields.file.url;
	    });
	
	    var serviceModelReports = ['AD', 'CG', 'DW', 'FG', 'GG'];
	    var modelType = resultString.sampleID.substring(0, 2);
	    var pdfReport = false;
	    if (serviceModelReports.indexOf(modelType) > 0) {
	        pdfReport = true;
	    }
	    $scope.pdfReport = pdfReport;
	
	    $scope.trackPdfDownload = function () {
	        $window.ga('send', 'pageview', {
	            'page': 'PdfDownload'
	        });
	    };
	}
	
	exports.default = angular.module('mars.vet.dnareports.controllers.navbar', ["ng"]).controller('NavbarController', navbarController).name;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-dialog\">\r\n\t<div class=\"modal-content\">\r\n\t\t<div class=\"modal-header\">\r\n\t\t\t<a class=\"modaldismiss\" ng-click=\"modalOptions.dismiss()\">&times;</a>\r\n\t\t</div>\r\n\t\t<div class=\"modal-body\">\r\n\t\t\t<div class=\"modaltext\" ng-bind-html=\"modalOptions.headerText\"></div>\r\n\t\t\t<div class=\"text-center\">\r\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary btn-customfwd modalupgradebtn\" ng-click=\"modalOptions.ok()\">Upgrade Now</button>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"text-center\">\r\n\t\t\t\t<a class=\"modalsublink\" href=\"#/notes/4L9cpL4sNqEAKIw2GKS0aG\" style=\"\" ng-click=\"modalOptions.close()\">Learn More</a>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"modal-footer\"></div>\r\n\t</div>\r\n</div>"

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.adultweight", []).controller('AdultWeightController', function ($rootScope, $scope, $routeParams, $window, EntryService, NavigationService, EntryIDService, ImageService, WeightListService, TranslationService, reportdata) {
	    'ngInject';
	
	    var sampleDetails = reportdata.sampleDetails;
	
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	    EntryService.getEntry(EntryIDService.getEntryID('Adult Weight')).then(function (response) {
	        var fields = response.fields;
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = fields.title;
	        }
	        $scope.title = fields.title;
	        $scope.description = fields.description;
	        $scope.subTitle = fields.subTitle;
	        $scope.pdMsgArray = [];
	        $scope.descriptionArray = [];
	        $scope.weightUnit = TranslationService.getTranslation('WeightMeasure');
	        $scope.predictedMessage = fields.predictedMessage.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);;
	        $scope.bodyWeightDescription = fields.bodyWeightDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);;
	
	        ImageService.getImageUrl('6IuGlHxtS0wo4WKAayuokQ').then(function (response) {
	            $scope.nutrition = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl('1jW4X1zE3O6EkIEYygos8G').then(function (response) {
	            $scope.excercise = response.data.fields.file.url;
	        });
	
	        angular.forEach($scope.description.split("\n"), function (value, key) {
	            if (value != '') {
	                $scope.descriptionArray.push(value);
	            }
	        });
	        $scope.weightList = WeightListService.getWeightList();
	
	        NavigationService.setNavigationUrls();
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	    }, function (error) {});
	}).name;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controller.breed", []).controller('BreedController', function ($rootScope, $scope, $routeParams, $window, BreedListService, EntryService, ImageService, NavigationService, TranslationService, EntryIDService, reportdata) {
	    var sampleDetails = reportdata.sampleDetails;
	
	    EntryService.getEntry($routeParams.entryId).then(function (response) {
	        $scope.translation = TranslationService.getTranslation;
	        $scope.breedName = response.fields.breedName;
	        $scope.breedData = response.fields.breedData;
	        $scope.description = $scope.breedData['History'];
	        $scope.appDescription = $scope.breedData['Variation description'];
	        $scope.breedTitle = $scope.breedData['WisdomMX Name'];
	        $scope.descriptionArray = [];
	        $scope.traitsArray = [];
	        $scope.breedExtName = $scope.breedData['Shorter Name'];
	        $scope.height = $scope.breedData['Height'];
	        $scope.heightAverage = $scope.breedData['Height Average'];
	        $scope.weightPet = $scope.breedData['Weight Observed'];
	        $scope.weightShow = $scope.breedData['Weight'];
	        var breedList = BreedListService.getBreedList();
	        $scope.count = breedList[$scope.breedName];
	        $scope.percentageValue = $scope.count * 100 / 8;
	        $rootScope.pageTitle = $scope.breedData['Shorter Name'] + ' - ' + $scope.percentageValue + '%';
	        $scope.title = $scope.breedData['Shorter Name'] + ' - ' + $scope.percentageValue + '%';
	        var traitTitle = "Recognize any of these [BREED NAME] behaviors in [DOG NAME]?";
	        $scope.traitTitle = traitTitle.replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME]", response.fields.breedName);
	
	        NavigationService.setNavigationUrls();
	
	        for (var k = 1; k <= 4; k++) {
	            $scope.traitsArray.push($scope.breedData['Trait ' + k]);
	        }
	
	        angular.forEach($scope.description.split("\n"), function (value, key) {
	            if (value != '') {
	                $scope.descriptionArray.push(value);
	            }
	        });
	
	        $scope.breedCarousel = [];
	
	        $scope.carouselImageList = response.fields.breedCarousel['CarouselImages'];
	        if ($scope.carouselImageList != '') {
	            $scope.qArr = $scope.carouselImageList.split(",");
	
	            for (var k = 0; k < $scope.qArr.length; k++) {
	                ImageService.getImageUrl($scope.qArr[k]).then(function (response) {
	                    $scope.breedCarousel.push(response.data.fields.file.url);
	                });
	            }
	        }
	        ImageService.getImageUrl($scope.breedData['Large JPG Name']).then(function (response) {
	            $scope.breedImg = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl($scope.breedData['Tail']).then(function (response) {
	            $scope.breedTail = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl($scope.breedData['Muzzle']).then(function (response) {
	            $scope.breedMuzzle = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl($scope.breedData['Ear']).then(function (response) {
	            $scope.breedEar = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl($scope.breedData['Scaled Name']).then(function (response) {
	            $scope.breedAppearance = response.data.fields.file.url;
	        });
	
	        $window.ga('send', 'pageview', {
	            'page': 'BreedProfile'
	        });
	    });
	}).name;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.breedlist", []).controller('BreedListController', function ($scope, EntryIDService, EntryService, BreedListService, ImageService, TranslationService) {
	
	    $scope.sortedBreedList = BreedListService.getSortedBreedList(false);
	    var breedDetails = {};
	    $scope.loaded = false;
	    var entryIdList = [];
	    angular.forEach($scope.sortedBreedList, function (value, key) {
	        var breedEntryId = EntryIDService.getEntryID(value['breed']);
	        entryIdList.push(breedEntryId);
	    });
	    $scope.translation = TranslationService.getTranslation;
	    TranslationService.getGlobalVariablesList().then(function () {
	        angular.forEach(entryIdList, function (value, key) {
	            EntryService.getEntry(value).then(function (response) {
	                var data = response.fields;
	                var breedDetail = {};
	                breedDetail['breedName'] = data.breedName;
	                breedDetail['description'] = data.breedData['History'];
	                breedDetail['height'] = data.breedData['Height'];
	                breedDetail['weightPet'] = data.breedData['Weight Observed'];
	                breedDetail['weightShow'] = data.breedData['Weight'];
	
	                var breedList = BreedListService.getBreedList();
	                $scope.count = breedList[data.breedName];
	                $scope.percentageValue = $scope.count * 100 / 8;
	                breedDetail['pageTitle'] = data.breedData['Shorter Name'] + ' - ' + $scope.percentageValue + '%';
	
	                var breedCarousel = [];
	                var carouselImageList = response.fields.breedCarousel['CarouselImages'];
	                if ($scope.carouselImageList != '') {
	                    var carouselArray = carouselImageList.split(",");
	                    for (var i = 0; i < carouselArray.length; i++) {
	                        ImageService.getImageUrl(carouselArray[i]).then(function (response) {
	                            breedCarousel.push('https:' + response.data.fields.file.url);
	                        });
	                    }
	                }
	                breedDetail['breedCarousel'] = breedCarousel;
	
	                var descriptionArray = [];
	
	                angular.forEach(breedDetail['description'].split("\n"), function (value, key) {
	                    if (value != '') {
	                        descriptionArray.push(value);
	                    }
	                });
	
	                breedDetail['descriptionArray'] = descriptionArray;
	
	                var traitsArray = [];
	
	                for (var k = 1; k <= 4; k++) {
	                    traitsArray.push(data.breedData['Trait ' + k]);
	                }
	                breedDetail['traitsArray'] = traitsArray;
	
	                ImageService.getImageUrl(data.breedData['Tail']).then(function (response) {
	                    breedDetail['breedTail'] = 'https:' + response.data.fields.file.url;
	                });
	                ImageService.getImageUrl(data.breedData['Muzzle']).then(function (response) {
	                    breedDetail['breedMuzzle'] = 'https:' + response.data.fields.file.url;
	                });
	                ImageService.getImageUrl(data.breedData['Ear']).then(function (response) {
	                    breedDetail['breedEar'] = 'https:' + response.data.fields.file.url;
	                });
	                ImageService.getImageUrl(data.breedData['Scaled Name']).then(function (response) {
	                    breedDetail['breedScale'] = 'https:' + response.data.fields.file.url;
	                });
	                breedDetails[data.breedName] = breedDetail;
	            });
	        });
	    });
	    $scope.breedDetails = breedDetails;
	}).name;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.breedanalyzed", []).controller('BreedsAnalyzedController', function ($rootScope, $scope, $window, EntryService, EntryIDService, BreedListService, TranslationService, NavigationService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	
	    var specificEvidenceList = BreedListService.getBreedList();
	    var groupEvidenceList = resultString.next5;
	
	    var evidenceList = [];
	
	    angular.forEach(specificEvidenceList, function (count, breed) {
	        if (breed != 'Mixed Breed Groups') {
	            evidenceList.push(breed);
	        }
	    });
	
	    if (specificEvidenceList['Mixed Breed Groups']) {
	        angular.forEach(groupEvidenceList, function (value, key) {
	            evidenceList.push(value);
	        });
	    }
	
	    EntryService.getEntry(EntryIDService.getEntryID('Breeds Analyzed')).then(function (response) {
	        var fields = response.fields;
	        var description = response.fields.description;
	        description = fields.description.replaceAll('[LINKREPLACE]', "<a class='leftnavigationlink' href='http://www.wisdompanel.com/breeds' target='_blank'>");
	        $scope.descriptionArray = [];
	        angular.forEach(description.split("\n"), function (value, key) {
	            if (value != '') {
	                $scope.descriptionArray.push(value);
	            }
	        });
	
	        $rootScope.pageTitle = fields.title;
	        $scope.title = fields.title;
	        $scope.subtitle = fields.subtitle;
	        NavigationService.setNavigationUrls();
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	    });
	
	    EntryService.getEntry(EntryIDService.getEntryID('Breed Group Mappings')).then(function (response) {
	
	        var fields = response.fields;
	        var breedGroups = fields.breedGroupMapping;
	
	        angular.forEach(breedGroups, function (breedGroup, breedGroupKey) {
	            breedGroup['EvidenceBreed'] = [];
	
	            angular.forEach(breedGroup['breedList'], function (breedList, breedListKey) {
	                angular.forEach(evidenceList, function (value, key) {
	                    if (breedList['breedname'] == value && breedList['enabled'] === true) {
	                        breedGroup['SpecificEvidence'] = TranslationService.getTranslation('Specific Evidence Found');
	                        breedGroup['EvidenceBreed'].push(value);
	                    } else if (breedGroup['breedGroup'] == value) {
	                        breedGroup['TraceEvidence'] = TranslationService.getTranslation('Trace Evidence Found');
	                    }
	                });
	            });
	            if (breedGroup['SpecificEvidence'] === undefined && breedGroup['TraceEvidence'] === undefined) {
	                breedGroup['NoEvidence'] = TranslationService.getTranslation('No Evidence Found');
	            }
	        });
	        $scope.breedGroups = breedGroups;
	    }, function (error) {});
	}).name;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.breedscertificate", []).controller('BreedsCertificateController', function ($rootScope, $scope, $window, EntryService, EntryIDService, ImageService, FileService, NavigationService, UtilityService, reportdata) {
	
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    $scope.sampleID = resultString.sampleID;
	
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	
	    EntryService.getEntry(EntryIDService.getEntryID('Certificate')).then(function (response) {
	        var fields = response.fields;
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = fields.title;
	        }
	        $scope.title = fields.title;
	        $scope.description = fields.description.replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);
	        var versionNo = Math.floor(Math.random() * 100 + 1);
	        var printCertificatePath = "/staticresources/dnareports/images/" + resultString.sampleID + "/certificate.png";
	        $scope.certificate = "/staticresources/dnareports/images/" + resultString.sampleID + "/certificate.png";
	        $scope.newCertificate = "/staticresources/dnareports/images/" + resultString.sampleID + "/certificateThumbnail.png";
	
	        $scope.fbs_click = UtilityService.fbs_click;
	        $scope.instagram_click = UtilityService.instagram_click;
	        $scope.twitter_click = UtilityService.twitter_click;
	        $scope.pinterest_click = UtilityService.pinterest_click;
	        $scope.printCertificate = UtilityService.printCertificate;
	
	        ImageService.getImageUrl('7dDa5QeYwMg6oOEUKUiOoO').then(function (response) {
	            $scope.fbImage = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl('6ehEkqryM0KMui0g8GESMm').then(function (response) {
	            $scope.twitterImage = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl('5chGCl2XVmA02sEYyamyc4').then(function (response) {
	            $scope.instagramImage = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl('4TtxdL2uk0AC46wE62kCW4').then(function (response) {
	            $scope.webImage = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl('rdcaYEa0xi2YW26gGOusw').then(function (response) {
	            $scope.pinterestImage = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl('5xExMvhUk0QG8cWO2kiGM0').then(function (response) {
	            $scope.certificateButton = response.data.fields.file.url;
	        });
	        $scope.fbicon = NavigationService.setNavigationUrls();
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	    }, function (error) {});
	}).name;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.breed", []).controller('BreedTestsController', function ($rootScope, $scope, $window, $http, $routeParams, EntryService, ImageService, NavigationService, FileService, EntryIDService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	    $scope.breedTests = resultString.resultPbDd !== undefined && resultString.resultPbDd.length > 0;
	    var resultPbDdBreed = resultString.resultPbDdBreed;
	    var breedName1 = "";
	    var breedName2 = "";
	    var pbDd = "";
	
	    if (resultPbDdBreed !== undefined && resultPbDdBreed !== null && resultPbDdBreed.length > 0) {
	        breedName1 = resultPbDdBreed[0]['breed_1'];
	        breedName2 = resultPbDdBreed[0]['breed_2'];
	        pbDd = resultPbDdBreed[0]['type'] == "Wisdom_PB" ? "PB" : resultPbDdBreed[0]['type'] == "Wisdom_DD" ? "DD" : "";
	    }
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	    EntryService.getEntry(EntryIDService.getEntryID('Breed Tests')).then(function (response) {
	
	        var fields = response.fields;
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = fields.title;
	        }
	        $scope.title = fields.title;
	        $scope.caption = fields.caption;
	
	        var boBreed = resultString['boBreed'];
	
	        if (boBreed !== undefined && boBreed != '') {
	            $scope.boBreedList = boBreed !== undefined && boBreed != '' ? boBreed.split(",") : "";
	            $scope.boBreed = boBreed;
	        }
	
	        $scope.pbddDropDowns = pbDd == 'PB' ? fields.pureBreedDropDowns : pbDd == "DD" ? fields.designerDogDropDowns : "";
	
	        $scope.pcaBlocksList = [];
	        $scope.pbddBreedList = [];
	        var resultPbDdData = [];
	        var resultPbDdData = resultString.resultPbDd;
	        $scope.description = "";
	        $scope.sampleID = resultString.sampleID;
	        resultPbDdData.push({
	            "evidence": 'notexpected',
	            "outcome": 'POSITIVE'
	        });
	        var status;
	        var style;
	        var cssClass;
	        var outcomeFinal;
	        var buildDropDown = [];
	        if (reportType != 'pdf') {
	            buildDropDown.push('ancestry_chart');
	        }
	        buildDropDown.push('pca_breed');
	        buildDropDown.push('pca_all');
	
	        if (pbDd == 'PB') {
	            buildDropDown.push('pca_nextbreed');
	            buildDropDown.push('pairwise_distance');
	            buildDropDown.push('pairwise_distance_topn');
	        } else if (pbDd == 'DD') {
	            buildDropDown.push('structure');
	        }
	        buildDropDown.push('homozygosity');
	        if (reportType != 'pdf') {
	            buildDropDown.push('notexpected');
	        }
	        var imageFileName;
	
	        angular.forEach(buildDropDown, function (value, key) {
	            angular.forEach($scope.pbddDropDowns, function (pbddData, evidence) {
	                if (value == evidence) {
	                    angular.forEach(resultPbDdData, function (resultSet, key) {
	
	                        if (resultSet['evidence'].trim() == 'final_outcome') {
	                            outcomeFinal = resultSet['outcome'];
	                        }
	                        var desc;
	                        var statusDesc;
	
	                        if (evidence == resultSet['evidence'].trim()) {
	                            if (resultSet['outcome'] == 'POSITIVE') {
	                                status = "PASS";
	                            } else if (resultSet['outcome'] == 'NEGATIVE') {
	                                status = "FAIL";
	                            } else if (resultSet['outcome'] == 'UNCERTAIN') {
	                                status = "INCONCLUSIVE";
	                            }
	
	                            if (evidence == 'notexpected') {
	                                status = "";
	                                style = "";
	                                cssClass = "";
	                            }
	                            var imgName = "";
	                            if (pbDd == 'PB') {
	                                if (evidence == 'homozygosity') {
	                                    imgName = 'HOMOZYGOSITY.png';
	                                } else if (evidence == 'pca_nextbreed') {
	                                    imgName = 'PCA_NEXTBREED.png';
	                                }
	                            }
	                            if (evidence == 'pca_all') {
	                                imgName = 'PCA_ALL.png';
	                            } else if (evidence == 'pca_breed') {
	                                imgName = 'PCA_BREED.png';
	                            } else if (evidence == 'ancestry_chart') {
	                                imgName = 'ancestrychart.png';
	                            }
	
	                            var repeatFlag = true;
	
	                            angular.forEach($scope.pcaBlocksList, function (value, key) {
	                                if (value['Box'] == 'notexpected') {
	                                    repeatFlag = false;
	                                }
	                            });
	
	                            if (resultSet['outcome'] != 'NORESULT') {
	                                if (pbDd == 'PB') {
	                                    desc = pbddData['Description'].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME]", breedName1);
	                                    statusDesc = pbddData[resultSet['outcome']].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME]", breedName1);
	                                } else if (pbDd == 'DD') {
	                                    desc = pbddData['Description'].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
	                                    statusDesc = pbddData[resultSet['outcome']].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
	                                }
	                                if (repeatFlag) {
	                                    $scope.pcaBlocksList.push({
	                                        "Box": evidence,
	                                        "Title": pbddData['Title'].trim(),
	                                        "Description": desc + statusDesc,
	                                        'StatusWiseDesc': statusDesc,
	                                        'Status': status,
	                                        'ColorCode': style,
	                                        'pcaImage': imgName
	                                    });
	                                }
	                            }
	                        }
	                    });
	                }
	            });
	        });
	
	        if (pbDd == 'PB') {
	            $scope.description = fields.pureBreedDescription[outcomeFinal].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME]", breedName1);
	            $scope.pbddBreedList.push(breedName1);
	        } else if (pbDd == 'DD') {
	
	            $scope.description = fields.designerDogDescription[outcomeFinal].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
	            $scope.pbddBreedList.push(breedName1);
	            $scope.pbddBreedList.push(breedName2);
	        }
	        $scope.pbddFlag = pbDd;
	
	        $scope.imgPath = "/staticresources/dnareports/images/" + resultString.sampleID;
	
	        NavigationService.setNavigationUrls();
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	    }, function (error) {});
	}).name;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.carrier", []).controller('CarrierController', function ($rootScope, $scope, $window, EntryService, EntryIDService, ImageService, NavigationService, TranslationService, DisorderDataService, reportdata) {
	
	    var sampleDetails = reportdata.sampleDetails;
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	
	    EntryService.getEntry(EntryIDService.getEntryID('Carrier')).then(function (response) {
	        var fields = response.fields;
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = fields.title;
	        }
	        $scope.title = fields.title;
	        $scope.description = fields.description;
	        $scope.copyDescription = fields.copyDescription.replaceAll('[PETNAME]', sampleDetails.petDetails.petName);
	    });
	
	    ImageService.getImageUrl('dXAc1Y0aPu4qqcgQ6GGaA').then(function (response) {
	        $scope.mainStatusIcon = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl('3m2L1bk9oQIGuK8Uw0SAk0').then(function (response) {
	        $scope.subStatusIcon = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl("M2jxxG0NKmumcEkciqmg0").then(function (response) {
	        $scope.wsuLogo = response.data.fields.file.url;
	    });
	
	    NavigationService.setNavigationUrls();
	    $scope.translation = TranslationService.getTranslation;
	    $scope.carrierDataList = DisorderDataService.getCarrierData();
	    $scope.locale = reportdata.locale;
	    var init = function init() {
	        $rootScope.$broadcast('checkGenHealthCount', $scope.carrierDataList.length);
	    };
	    init();
	    $window.ga('send', 'pageview', {
	        'page': $scope.title
	    });
	}).directive('tooltip', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            $(element).hover(function () {
	                $(element).tooltip('show');
	            }, function () {
	                $(element).tooltip('hide');
	            });
	        }
	    };
	}).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.nocall", []).controller('NoCallController', function ($rootScope, $scope, $window, EntryService, EntryIDService, ImageService, NavigationService, TranslationService, DisorderDataService, reportdata) {
	    'ngInject';
	
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	    EntryService.getEntry(EntryIDService.getEntryID('No Call')).then(function (response) {
	        var fields = response.fields;
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = fields.title;
	        }
	        $scope.title = fields.title;
	        $scope.description = fields.description;
	    });
	
	    ImageService.getImageUrl('hHESnv8aSkayeuUkcIEOK').then(function (response) {
	        $scope.mainStatusIcon = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl('3fc0BjHymsymwmYkII4mMo').then(function (response) {
	        $scope.subStatusIcon = response.data.fields.file.url;
	    });
	
	    $scope.translation = TranslationService.getTranslation;
	    NavigationService.setNavigationUrls();
	    $scope.nocallDataList = DisorderDataService.getNoCallData();
	    $scope.locale = reportdata.locale;
	    $window.ga('send', 'pageview', {
	        'page': $scope.title
	    });
	}).name;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _lodash = __webpack_require__(36);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = angular.module("mars.vet.dnareports.controllers.allclear", []).controller('AllClearController', function ($rootScope, $scope, $window, EntryService, EntryIDService, ImageService, NavigationService, TranslationService, DisorderDataService, reportdata) {
	
	        var reportType = 'online';
	        $scope.onloadFun = function () {
	                reportType = 'pdf';
	        };
	
	        EntryService.getEntry(EntryIDService.getEntryID('All Clear')).then(function (response) {
	                var fields = response.fields;
	                if (reportType != 'pdf') {
	                        $rootScope.pageTitle = fields.title;
	                }
	                $scope.title = fields.title;
	                $scope.description = fields.description;
	                $scope.subtitle = fields.subtitle;
	        });
	
	        var disorders = DisorderDataService.getDisorders();
	        var disorderKeySet = Object.keys(disorders);
	        var allClear = DisorderDataService.getAllClearData();
	        var disorderMap = {};
	        var diseaseCategory = [];
	
	        _.each(disorderKeySet, function (key) {
	                var disorder = disorders[key];
	                if (!disorderMap[disorder.diseaseCategory]) {
	                        disorderMap[disorder.diseaseCategory] = new Array();
	                        diseaseCategory.push(disorder.diseaseCategory);
	                }
	        });
	
	        _.each(allClear, function (clearedDisorder) {
	                var disorder = disorders[clearedDisorder.locusName];
	                if (!disorder) {
	                        return;
	                }
	                disorderMap[disorder.diseaseCategory].push({
	                        locusname: disorder.locusname,
	                        diseaseLongName: disorder.diseaseLongName,
	                        entryId: disorder.entryId,
	                        diseaseCategory: disorder.diseaseCategory
	                });
	        });
	
	        _.each(diseaseCategory, function (category) {
	                disorderMap[category].sort(function (a, b) {
	                        return a.diseaseLongName < b.diseaseLongName ? -1 : a.diseaseLongName > b.diseaseLongName ? 1 : 0;
	                });
	        });
	
	        $scope.disorderMap = disorderMap;
	
	        ImageService.getImageUrl('JwWqM1wbQIEAMiSeoakKk').then(function (response) {
	                $scope.mainStatusIcon = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl('28BD224gKUUocC2WC2MuGE').then(function (response) {
	                $scope.subStatusIcon = response.data.fields.file.url;
	        });
	        NavigationService.setNavigationUrls();
	        $scope.translation = TranslationService.getTranslation;
	        $scope.locale = reportdata.locale;
	        $window.ga('send', 'pageview', {
	                'page': $scope.title
	        });
	}).name;

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module('mars.vet.dnareports.controllers.atrisk', []).controller('AtRiskController', function ($rootScope, $scope, $window, EntryService, EntryIDService, ImageService, DisorderDataService, NavigationService, TranslationService, reportdata, disorderData) {
	    var sampleDetails = reportdata.sampleDetails;
	
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	    EntryService.getEntry(EntryIDService.getEntryID('At Risk')).then(function (response) {
	        var fields = response.fields;
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = fields.title;
	        }
	        $scope.title = fields.title;
	        $scope.description = fields.description.replaceAll('[PETNAME]', sampleDetails.petDetails.petName);
	        $scope.copyDescription = fields.copyDescription.replaceAll('[PETNAME]', sampleDetails.petDetails.petName);
	    });
	
	    ImageService.getImageUrl('3Wnl92bJlSmi6gIYKKkE0C').then(function (response) {
	        $scope.mainStatusIcon = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl('6ucbwArbUcuYsYYKmemcWM').then(function (response) {
	        $scope.subStatusIcon = response.data.fields.file.url;
	    });
	    ImageService.getImageUrl("M2jxxG0NKmumcEkciqmg0").then(function (response) {
	        $scope.wsuLogo = response.data.fields.file.url;
	    });
	
	    $scope.translation = TranslationService.getTranslation;
	
	    NavigationService.setNavigationUrls();
	    $scope.atRiskDataList = DisorderDataService.getAtRiskData();
	    $scope.locale = reportdata.locale;
	    var init = function init() {
	        $rootScope.$broadcast('checkGenHealthCount', $scope.atRiskDataList.length);
	    };
	    init();
	    $window.ga('send', 'pageview', {
	        'page': $scope.title
	    });
	}).directive('tooltip', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            $(element).hover(function () {
	                $(element).tooltip('show');
	            }, function () {
	                $(element).tooltip('hide');
	            });
	        }
	    };
	}).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controller.eic", []).controller('EICController', function ($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService, TranslationService, UtilityService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    $scope.getVersionFeature = UtilityService.getVersionFeature('EIC');
	    if ($scope.getVersionFeature) {
	        var reportType = 'online';
	        $scope.onloadFun = function () {
	            reportType = 'pdf';
	        };
	        EntryService.getEntry(EntryIDService.getEntryID('Exercise Induced Collapse')).then(function (response) {
	            var fields = response.fields;
	
	            if (reportType != 'pdf') {
	                $rootScope.pageTitle = fields.title;
	            }
	            $scope.title = fields.title;
	            var disorderSnps = resultString.disorderSnps;
	            var eicOutcome;
	            var eicCopies;
	            var eicStatus;
	            var eicDesc = "";
	            angular.forEach(disorderSnps, function (result, key) {
	                if (disorderSnps !== undefined && disorderSnps.length > 0 && result['snp_name'].indexOf("DNM1") != -1) {
	                    eicOutcome = result['outcome'];
	                    eicCopies = result['copies'];
	                }
	            });
	            if (eicOutcome == 'negative' && eicCopies == 0) {
	                eicStatus = TranslationService.getTranslation('Clear');
	                eicDesc = fields.description['Clear'];
	            } else if (eicOutcome == 'positive' && eicCopies == 1) {
	                eicStatus = TranslationService.getTranslation('Carrier');
	                eicDesc = fields.description['Carrier'];
	            } else if (eicOutcome == 'positive' && eicCopies == 2) {
	                eicStatus = TranslationService.getTranslation('Affected');
	                eicDesc = fields.description['Affected'];
	            } else if (eicOutcome == 'fail' && eicCopies == -1) {
	                eicStatus = TranslationService.getTranslation('Failed');
	                eicDesc = fields.description['Failed'];
	            }
	            $scope.eicAccordions = fields.eicAccordions;
	            $scope.commonMsg = fields.description['Common'].replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
	            $scope.outcome = eicStatus;
	            $scope.mainDesc = fields.description['MAINDESC'].replaceAll('[DOG NAME]', sampleDetails.petDetails.petName).replaceAll('[STATUS]', eicStatus);
	            $scope.eicDescription = eicDesc.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
	            NavigationService.setNavigationUrls();
	            $window.ga('send', 'pageview', {
	                'page': $rootScope.pageTitle
	            });
	        }, function (error) {});
	    }
	}).name;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.exceptionletter", []).controller('ExceptionLetterController', function ($rootScope, $scope, $window, EntryService, NavigationService, TranslationService, EntryIDService, UtilityService, reportdata) {
	
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    var letter = "/staticresources/dnareports/images/" + resultString.sampleID + "/lettercontent.xml";
	    $scope.letterTest = letter;
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	    EntryService.getEntry('57xEDReh84GyeuiCsC4YCW').then(function (response) {
	        var fields = response.fields;
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = TranslationService.getTranslation("Notes");
	        }
	        $scope.title = TranslationService.getTranslation("Notes");
	        $scope.lastName = sampleDetails.ownerName.lastName;
	        $scope.firstName = sampleDetails.ownerName.firstName;
	        $scope.attentionMsg = "Attenion! " + $scope.lastName;
	        var letterContent = "";
	        var d = resultString.event[0]['eventDate'];
	        var letterFlag = resultString.event[0]['letterflag'];
	        $scope.date = UtilityService.formatDate(d);
	        if (letterFlag == 'REVISED') {
	            letterContent = fields.exceptionLetters['RevisedReport'];
	        } else if (letterFlag == 'AUTODETAILED') {
	            letterContent = fields.exceptionLetters['DetailedAnalysis'];
	        } else if (letterFlag == 'REPEAT') {
	            letterContent = fields.exceptionLetters['RepeatTrapped'];
	        }
	        $scope.exceptionLetter = letterContent.replaceAll('[PETNAME]', sampleDetails.petDetails.petName).replaceAll('[SAMPLEID]', resultString.sampleID).replaceAll('[CLIENT]', $scope.lastName);
	        $scope.descriptionArray = [];
	        $scope.exceptionLetterFlag = letterFlag;
	        angular.forEach($scope.exceptionLetter.split("\n"), function (value, key) {
	            if (value != '') {
	                $scope.descriptionArray.push(value);
	            }
	        });
	        var init = function init() {
	            $rootScope.$broadcast('checkNotifyCount', 1);
	        };
	        init();
	        $window.ga('send', 'pageview', {
	            'page': 'ExceptionLetter'
	        });
	    }, function (error) {});
	}).name;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.faq", []).controller('FaqsController', function ($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService) {
	    'ngInject';
	
	    EntryService.getEntry(EntryIDService.getEntryID('FAQs')).then(function (response) {
	        var fields = response.fields;
	        $rootScope.pageTitle = fields.title;
	        $scope.breedQuestions = fields.breedQuestions;
	        $scope.scienceQuestions = fields.scienceQuestions;
	        $scope.faqsubtitle = fields.faqsubtitle;
	        $scope.description = fields.description;
	        $scope.OpenPopupWindow = function () {
	            $window.open("http://www.aspsnippets.com/", "popup", "width=300,height=200,left=10,top=150");
	        };
	        NavigationService.setNavigationUrls();
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	    });
	}).name;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.glossary", []).controller('GlossaryController', function ($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService) {
	    'ngInject';
	
	    var entryID = $routeParams.entryID;
	
	    EntryService.getEntry(EntryIDService.getEntryID('Glossary')).then(function (response) {
	        var fields = response.fields;
	        $rootScope.pageTitle = fields.Title;
	        $scope.glossaryText = fields.glossary.split("\n");
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	        NavigationService.setNavigationUrls();
	    });
	}).name;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.health", []).controller('HealthController', function ($rootScope, $scope, $window, $uibModal, EntryService, EntryIDService, DisorderDataService, ImageService, NavigationService, TranslationService, UtilityService, WeightListService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	
	    $scope.open = function () {
	        var modalInstance = $uibModal.open({
	            template: __webpack_require__(26),
	            controller: 'UpgradeModalController'
	        });
	    };
	
	    EntryService.getEntry(EntryIDService.getEntryID('Health')).then(function (response) {
	
	        var fields = response.fields;
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = fields.title;
	        }
	
	        $scope.title = fields.title;
	        $scope.description = fields.description.replace("[DOG NAME]", sampleDetails.petDetails.petName);
	        $scope.seeDetails = TranslationService.getTranslation('See Details');
	        $scope.getVersionFeature = UtilityService.getVersionFeature;
	        var mdr1_enabled = UtilityService.getVersionFeature('MDR1');
	        var traits_enabled = UtilityService.getVersionFeature('Traits');
	        var eic_enabled = UtilityService.getVersionFeature('EIC');
	
	        $scope.allowUpgrade = sampleDetails.upgrade;
	
	
	        if (mdr1_enabled) {
	            var mdrOutcome;
	            var copies;
	            var mdrStatus;
	
	            $scope.multiDrugSensitivity = TranslationService.getTranslation('Multidrug Sensitivity');
	            $scope.multiDrugSensitivityEntryID = EntryIDService.getEntryID('Multidrug Sensitivity');
	            $scope.translation = TranslationService.getTranslation;
	
	            ImageService.getImageUrl("7L4BPe98OIYYoIO4MoyOMU").then(function (response) {
	                $scope.mdr1ImageUrl = response.data.fields.file.url;
	            });
	
	            var disorderSnps = resultString.disorderSnps;
	            angular.forEach(disorderSnps, function (result, key) {
	                if (disorderSnps !== undefined && disorderSnps.length > 0 && result['snp_name'].indexOf("MDR1") != -1) {
	                    mdrOutcome = result['outcome'];
	                    copies = result['copies'];
	                }
	            });
	            $scope.disorderSnps = resultString.disorderSnps[0];
	            $scope.outcome = TranslationService.getTranslation('Normal/Normal');
	            var multiDrugDescription = "";
	
	            if (mdrOutcome == 'negative' && copies == 0) {
	                mdrStatus = TranslationService.getTranslation('Normal/Normal', true);
	                multiDrugDescription = fields.normalNormal;
	            } else if (mdrOutcome == 'positive' && copies == 1) {
	                mdrStatus = TranslationService.getTranslation('Mutant/Normal', true);
	                multiDrugDescription = fields.mutantNormal;
	            } else if (mdrOutcome == 'positive' && copies == 2) {
	                mdrStatus = TranslationService.getTranslation('Mutant/Mutant', true);
	                multiDrugDescription = fields.mutantMutant;
	            } else if (mdrOutcome == 'fail' && copies == -1) {
	                mdrStatus = TranslationService.getTranslation('Failed', true);
	                multiDrugDescription = fields.failureDescription;
	            }
	
	            $scope.multiDrugDescription = multiDrugDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName).replaceAll('[copy value]', copies);
	            $scope.outcome = mdrStatus;
	            $scope.copies = copies;
	        }
	
	        if (UtilityService.getVersionFeature('WisdomHealth')) {
	            $scope.atRiskEntryID = EntryIDService.getEntryID('At Risk');
	            $scope.carrierEntryID = EntryIDService.getEntryID('Carrier');
	            $scope.allClearEntryID = EntryIDService.getEntryID('All Clear');
	            $scope.noCallEntryID = EntryIDService.getEntryID('No Call');
	
	            $scope.atRiskData = DisorderDataService.getAtRiskData();
	            $scope.carrierData = DisorderDataService.getCarrierData();
	            $scope.noCallData = DisorderDataService.getNoCallData();
	            $scope.allClearData = DisorderDataService.getAllClearData();
	
	            var totalDisorderCount = $scope.atRiskData.length + $scope.carrierData.length + $scope.noCallData.length + $scope.allClearData.length;
	            var disorderCount = $scope.atRiskData.length + $scope.carrierData.length + $scope.noCallData.length;
	            var geneticHealthDescription;
	
	            if (disorderCount > 0) {
	                geneticHealthDescription = fields.geneticHealthDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName).replaceAll('[DISORDERCOUNT]', totalDisorderCount);
	            } else {
	                geneticHealthDescription = fields.clearDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
	            }
	
	            $scope.geneticHealthDescription = geneticHealthDescription;
	
	            ImageService.getImageUrl("1UJcKEfSy86QWQsKC2YwMC").then(function (response) {
	                $scope.gHealthIcon = response.data.fields.file.url;
	            });
	
	            ImageService.getImageUrl("6ucbwArbUcuYsYYKmemcWM").then(function (response) {
	                $scope.atRiskIcon = response.data.fields.file.url;
	            });
	
	            ImageService.getImageUrl("3m2L1bk9oQIGuK8Uw0SAk0").then(function (response) {
	                $scope.carrierIcon = response.data.fields.file.url;
	            });
	            ImageService.getImageUrl("28BD224gKUUocC2WC2MuGE").then(function (response) {
	                $scope.allClearIcon = response.data.fields.file.url;
	            });
	
	            ImageService.getImageUrl("3fc0BjHymsymwmYkII4mMo").then(function (response) {
	                $scope.nocallIcon = response.data.fields.file.url;
	            });
	        }
	
	        $scope.adultWeight = TranslationService.getTranslation('Adult Weight');
	        $scope.videoDescription = fields.videoDescription;
	
	
	        if (UtilityService.getVersionFeature('Traits')) {
	            $scope.traits = TranslationService.getTranslation('Traits');
	
	            ImageService.getImageUrl("58xdnsFUhySIusyYyCaWUq").then(function (response) {
	                $scope.traitsImageUrl = response.data.fields.file.url;
	                $scope.traitsEntryID = EntryIDService.getEntryID('Traits');
	            });
	        }
	
	        ImageService.getImageUrl("1o198Nn73O244sGss8IC2A").then(function (response) {
	            $scope.adultWeightUrl = response.data.fields.file.url;
	            $scope.adultWeightEntryID = EntryIDService.getEntryID('Adult Weight');
	        });
	
	        if (UtilityService.getVersionFeature('EIC') === true) {
	            var eicOutcome;
	            var eicCopies;
	            var eicStatus;
	            var eicDesc = "";
	
	            angular.forEach(disorderSnps, function (result, key) {
	                if (disorderSnps !== undefined && disorderSnps.length > 0 && result['snp_name'].indexOf("DNM1") != -1) {
	                    eicOutcome = result['outcome'];
	                    eicCopies = result['copies'];
	                }
	            });
	            if (eicOutcome == 'negative' && eicCopies == 0) {
	                eicStatus = TranslationService.getTranslation('Clear');
	                eicDesc = fields.eicStatusDescription['Clear'];
	            } else if (eicOutcome == 'positive' && eicCopies == 1) {
	                eicStatus = TranslationService.getTranslation('Carrier');
	                eicDesc = fields.eicStatusDescription['Carrier'];
	            } else if (eicOutcome == 'positive' && eicCopies == 2) {
	                eicStatus = TranslationService.getTranslation('Affected');
	                eicDesc = fields.eicStatusDescription['Affected'];
	            } else if (eicOutcome == 'fail' && eicCopies == -1) {
	                eicStatus = TranslationService.getTranslation('Failed');
	                eicDesc = fields.eicStatusDescription['Failed'];
	            }
	            $scope.eicDescription = eicDesc.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
	            $scope.eicStatus = eicStatus;
	
	            ImageService.getImageUrl("tqsyNVWTYW8q08KMwsYMi").then(function (response) {
	                $scope.eicImageUrl = response.data.fields.file.url;
	            });
	        }
	
	        $scope.weightUnit = TranslationService.getTranslation('WeightMeasure');
	        $scope.weightList = [];
	        $scope.adultWeight = TranslationService.getTranslation('Adult Weight');
	        $scope.weightList = WeightListService.getWeightList();
	        $scope.adultWeightDescription = fields.adultWeightDescription.replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);
	        $scope.traitsDescription = fields.traitsDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
	        NavigationService.setNavigationUrls();
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	    }, function (error) {});
	}).name;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module('mars.vet.dnareports.controllers.homepage', []).controller('HomePageController', function ($rootScope, $scope, $window, EntryService, ImageService, EntryIDService, NavigationService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    $scope.type = 'success';
	    $scope.message = '';
	
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	
	    $scope.resultString = resultString;
	    $scope.sampleID = resultString.sampleID;
	    EntryService.getEntry(EntryIDService.getEntryID('HomePage')).then(function (response) {
	        $scope.flyoverMessage = 'It appears we have tested ' + sampleDetails.petDetails.petName + ' before! ';
	        $scope.resultset = response.fields;
	
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = $scope.resultset.title.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
	        }
	        $scope.title = $scope.resultset.title.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
	        $scope.description = $scope.resultset.description.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
	        $scope.imgdescription = $scope.resultset.imageDescription.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
	        $scope.geneticDescription = $scope.resultset.geneticDescription;
	        $scope.snpString = resultString.snpString.substring(1, Math.min(750, resultString.snpString.length));
	        var testimonial = $scope.resultset.testimonial;
	        $scope.range = testimonial['STARS'];
	        $scope.stars = [];
	
	        for (var k = 1; k <= $scope.range; k++) {
	            $scope.stars.push(k);
	        }
	
	        $scope.resultString = resultString;
	
	        EntryService.getEntry(EntryIDService.getEntryID('HomePage')).then(function (response) {
	            $scope.flyoverMessage = 'It appears we have tested ' + sampleDetails.petDetails.petName + ' before! ';
	            $scope.resultset = response.fields;
	
	            if (reportType != 'pdf') {
	                $rootScope.pageTitle = $scope.resultset.title.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
	            }
	            $scope.title = $scope.resultset.title.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
	            $scope.description = $scope.resultset.description.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
	            $scope.imgdescription = $scope.resultset.imageDescription.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
	            $scope.geneticDescription = $scope.resultset.geneticDescription;
	            $scope.snpString = resultString.snpString.substring(1, Math.min(750, resultString.snpString.length));
	            var testimonial = $scope.resultset.testimonial;
	            $scope.range = testimonial['STARS'];
	            $scope.stars = [];
	
	            for (var k = 1; k <= $scope.range; k++) {
	                $scope.stars.push(k);
	            }
	
	            var box1Parameters = testimonial['BOX1'].split('&');
	            $scope.box1Title = box1Parameters[0];
	            $scope.box1 = box1Parameters[1];
	            $scope.box2 = testimonial['BOX2'];
	            $scope.box3 = testimonial['BOX3'];
	            ImageService.getImageUrl('4k2GdTv73O6ykOcYiyWceq').then(function (response) {
	                $scope.homeImageUrl = response.data.fields.file.url;
	            });
	            ImageService.getImageUrl('61bcbQxfDagOewy8EGYYg').then(function (response) {
	                $scope.starRating = response.data.fields.file.url;
	            });
	            NavigationService.setNavigationUrls();
	            $window.ga('send', 'pageview', {
	                'page': 'HomePage'
	            });
	        }, function (error) {});
	    }, function (error) {});
	}).name;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.inheritance", []).controller('InheritanceController', function ($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService) {
	    EntryService.getEntry(EntryIDService.getEntryID('Inheritance')).then(function (response) {
	        var fields = response.fields;
	        $rootScope.pageTitle = fields.title;
	        $scope.heading = fields.heading;
	        var inheritanceText = fields.text.split("\n");
	        $scope.paragraph_1 = inheritanceText.length > 0 ? inheritanceText[0] : '';
	        $scope.paragraph_2 = inheritanceText.length > 1 ? inheritanceText[1] : '';
	        $scope.paragraph_3 = inheritanceText.length > 2 ? inheritanceText[2] : '';
	        $scope.paragraph_4 = inheritanceText.length > 3 ? inheritanceText[3] : '';
	
	        $scope.link = fields.link;
	        $scope.inheritanceEntryID = EntryIDService.getEntryID('Inheritance');
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	
	        NavigationService.setNavigationUrls();
	    });
	}).name;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.learnmore", []).controller('LearnMoreController', function ($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService, UtilityService) {
	    'ngInject';
	
	    EntryService.getEntry($routeParams.entryID).then(function (response) {
	        var fields = response.fields;
	        $rootScope.pageTitle = fields.title;
	        $scope.description = fields.description;
	        $scope.theScienceTitle = fields.theScience.title;
	        $scope.theScienceDescription = fields.theScience.description;
	        $scope.theScienceLink = fields.theScience.link;
	        $scope.theScienceEntryID = EntryIDService.getEntryID('The Science');
	        $scope.ourTechnologyTitle = fields.ourTechnology.title;
	        $scope.ourTechnologyDescription = fields.ourTechnology.description;
	        $scope.ourTechnologyLink = fields.ourTechnology.link;
	        $scope.ourTechnologyEntryID = EntryIDService.getEntryID('Our Technology');
	        $scope.inheritanceTitle = fields.inheritance.title;
	        $scope.inheritanceDescription = fields.inheritance.description;
	        $scope.inheritanceLink = fields.inheritance.link;
	        $scope.inheritanceEntryID = EntryIDService.getEntryID('Inheritance');
	        $scope.traitsTitle = fields.traits.title;
	        $scope.traitsDescription = fields.traits.description;
	        $scope.traitsLink = fields.traits.link;
	        $scope.traitsEntryID = EntryIDService.getEntryID('LearnMoreTraits');
	        $scope.identifyingBreedsTitle = fields.identifyingBreeds.title;
	        $scope.identifyingBreedsDescription = fields.identifyingBreeds.description;
	        $scope.identifyingBreedsLink = fields.identifyingBreeds.link;
	        $scope.faqsTitle = fields.commonQuestions.title;
	        $scope.faqsDescription = fields.commonQuestions.description;
	        $scope.faqsLink = fields.commonQuestions.link;
	        $scope.faqsEntryID = EntryIDService.getEntryID('FAQs');
	        $scope.glossaryTitle = fields.glossary.title;
	        $scope.glossaryDescription = fields.glossary.description;
	        $scope.glossaryEntryID = EntryIDService.getEntryID('Glossary');
	
	        $scope.getVersionFeature = UtilityService.getVersionFeature;
	
	        $scope.glossaryLink = fields.glossary.link;
	
	        NavigationService.setNavigationUrls();
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	    }, function (error) {});
	}).name;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.mixedcomponent", []).controller('MixedComponentController', function ($rootScope, $scope, $routeParams, $window, BreedListService, NavigationService, EntryService, EntryIDService, ImageService, reportdata) {
	    'ngInject';
	
	    var sampleDetails = reportdata.sampleDetails;
	    var resultString = reportdata.resultString;
	    $scope.mixBreedFlag = "false";
	    $scope.breedList = BreedListService.getSortedBreedList();
	
	    angular.forEach($scope.breedList, function (result, key) {
	        if (result['breed'] == 'Mixed Breed Groups') {
	            $scope.mixBreedFlag = "true";
	        }
	    });
	
	    if ($scope.mixBreedFlag != 'false') {
	
	        var reportType = 'online';
	        $scope.onloadFun = function () {
	            reportType = 'pdf';
	        };
	
	        EntryService.getEntry(EntryIDService.getEntryID('Mixed Breed Groups')).then(function (response) {
	            var fields = response.fields;
	
	            $scope.subTitle = "What does Mixed-breed or “Groups” mean for " + sampleDetails.petDetails.petName + "?";
	            $scope.description = fields.description.replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);
	
	            var breedList = BreedListService.getBreedList();
	            $scope.count = breedList['Mixed Breed Groups'];
	            if (reportType != 'pdf') {
	                $rootScope.pageTitle = fields.title + ' - ' + breedList['Mixed Breed Groups'] * 100 / 8 + '%';
	            }
	            $scope.title = fields.title + ' - ' + breedList['Mixed Breed Groups'] * 100 / 8 + '%';
	            NavigationService.setNavigationUrls();
	            $window.ga('send', 'pageview', {
	                'page': 'Mixed Component'
	            });
	        }, function (error) {});
	
	        var next5BreedGroupList = [];
	
	        EntryService.getEntry(EntryIDService.getEntryID('Breed Group Mappings')).then(function (response) {
	
	            var breedGroups = response.fields.breedGroups;
	
	            angular.forEach(resultString.next5, function (value, key) {
	                var carouselArray = [];
	                angular.forEach(breedGroups[value]['carouselImages'], function (value, key) {
	                    if (value !== null && value != "") {
	                        carouselArray.push(value);
	                    }
	                });
	                next5BreedGroupList.push({
	                    'GroupName': value,
	                    'Description': breedGroups[value]['description'],
	                    'GroupImages': carouselArray,
	                    'GroupBreeds': breedGroups[value]['carouselBreeds'],
	                    'groupIcon': breedGroups[value]['groupIcon']
	                });
	            });
	            angular.forEach(resultString.next5, function (value, key) {
	                ImageService.getImageUrl(breedGroups[value]['groupIcon']).then(function (response) {
	                    if (response.data.fields.file.url !== undefined) {
	                        angular.forEach(next5BreedGroupList, function (value, key) {
	                            if (breedGroups[value['GroupName']]['groupIcon'] == response.data.sys.id) {
	                                value['GroupIcon'] = response.data.fields.file.url;
	                            }
	                        });
	                    }
	                });
	            });
	            $scope.next5BreedGroups = next5BreedGroupList;
	        });
	    }
	}).name;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.multidrugsensitivity", []).controller('MultidrugSensitivityController', function ($rootScope, $scope, $window, EntryService, EntryIDService, NavigationService, TranslationService, ImageService, UtilityService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    $scope.getVersionFeature = UtilityService.getVersionFeature('MDR1');
	    if ($scope.getVersionFeature) {
	        var reportType = 'online';
	        $scope.onloadFun = function () {
	            reportType = 'pdf';
	        };
	
	        EntryService.getEntry(EntryIDService.getEntryID('Multidrug Sensitivity')).then(function (response) {
	            var fields = response.fields;
	            if (reportType != 'pdf') {
	                $rootScope.pageTitle = fields.title;
	            }
	            $scope.title = fields.title;
	            $scope.descriptionTitle = fields.description.title;
	            $scope.description = fields.description.description;
	            $scope.breedsAffected = fields.breedsAffected;
	            $scope.drugsAffected = fields.drugsAffected;
	            $scope.testOrigin = fields.testOrigin;
	            $scope.testOriginDesc = $scope.testOrigin.description.replaceAll('[LINKREPLACE]', "<a onclick='instagram_click(this)' >Washington State University</a>");
	            var mdrOutcome;
	            var copies;
	            var mdrStatus;
	            var disorderSnps = resultString.disorderSnps;
	
	            ImageService.getImageUrl("M2jxxG0NKmumcEkciqmg0").then(function (response) {
	                $scope.wsuLogo = response.data.fields.file.url;
	            });
	            angular.forEach(disorderSnps, function (result, key) {
	                if (disorderSnps !== undefined && disorderSnps.length > 0 && result['snp_name'].indexOf("MDR1") != -1) {
	                    mdrOutcome = result['outcome'];
	                    copies = result['copies'];
	                }
	            });
	            if (mdrOutcome == 'negative' && copies == '0') {
	                mdrStatus = TranslationService.getTranslation('Normal/Normal');
	            } else if (mdrOutcome == 'positive' && copies == '1') {
	                mdrStatus = TranslationService.getTranslation('Mutant/Normal');
	            } else if (mdrOutcome == 'positive' && copies == '2') {
	                mdrStatus = TranslationService.getTranslation('Mutant/Mutant');
	            } else if (mdrOutcome == 'fail' && copies == -1) {
	                mdrStatus = TranslationService.getTranslation('Failed');
	            }
	
	            $scope.outcome = mdrStatus;
	            var resultSet = response.fields.testResultsAnalysis[mdrStatus];
	            $scope.resultBoxLine1 = resultSet['Line1'].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);
	            $scope.resultBoxLine2 = resultSet['Line2'];
	            $scope.resultBoxLine3 = resultSet['Line3'].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);
	            $scope.resultAnalysis = resultSet['Test Results Analysis'];
	
	            NavigationService.setNavigationUrls();
	            $window.ga('send', 'pageview', {
	                'page': $rootScope.pageTitle
	            });
	        }, function (error) {});
	    }
	}).name;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.notes", []).controller('NotesController', function ($rootScope, $scope, $window, EntryService, EntryIDService, ImageService, NavigationService, TranslationService, UtilityService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	
	    EntryService.getEntry(EntryIDService.getEntryID('Notes')).then(function (response) {
	        var fields = response.fields;
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = fields.title;
	        }
	        $scope.title = fields.title;
	        $scope.description = fields.description;
	        $scope.translation = TranslationService.getTranslation;
	        $scope.couponCode = sampleDetails.couponCode;
	        $scope.qaTitle = fields.qaTitle;
	        $scope.qaDescription = fields.qaDescription;
	        $scope.couponDescription = fields.couponDescription;
	        $scope.coupon = fields.coupon;
	        $scope.upgradeTitle = fields.upgradeTitle;
	        $scope.allowUpgrade = sampleDetails.upgrade;
	        var upgradeDescription = fields.upgradeDescription.replace("[PETNAME]", sampleDetails.petDetails.petName);
	        $scope.upgradeDescription = upgradeDescription.replace("[LINK]", "<a class='leftnavigationlink' href='https://wisdompanel.com/mdr1_disease_screening', target='_blank'>");
	
	
	        $scope.noLetterDescription = fields.noLetterDescription;
	        $scope.upgradeNowUrl = fields.upgradeNowUrl.replace("<sampleID>", resultString.sampleID);
	        $scope.buyNowUrl = fields.buyNowPageUrl;
	        var letterFlag = "";
	        if (resultString.event !== null && resultString.event !== undefined && resultString.event.length > 0) {
	            $scope.pbddDate = UtilityService.formatDate(resultString.event[0]['eventDate']);
	            $scope.exceptionDate = UtilityService.formatDate(resultString.event[0]['eventDate']);
	        } else {
	            $scope.pbddDate = "";
	            $scope.exceptionDate = "";
	        }
	        var resultPbDdBreed = resultString.resultPbDdBreed;
	        if (resultPbDdBreed !== undefined && resultPbDdBreed !== null && resultPbDdBreed.length > 0) {
	            letterFlag = resultPbDdBreed[0]['type'] == "Wisdom_PB" ? "PB" : resultPbDdBreed[0]['type'] == "Wisdom_DD" ? "DD" : "";
	        }
	        if (letterFlag == 'PB') {
	            $scope.letterTitle = "Purebred Analysis Letter";
	            $scope.letterBody = "We have run your test as a Purebred Test and these are our findings.";
	        } else if (letterFlag == 'DD') {
	            $scope.letterTitle = "First-generation Cross Analysis Letter";
	            $scope.letterBody = "We have run your test as a Designer Dog Test and these are our findings.";
	        }
	
	        $scope.pbddLetterFlag = letterFlag;
	        var exceptionLetterFlag = 'false';
	
	        if (resultString.event[0] !== null && resultString.event[0] !== undefined && resultString.event[0]['letterflag'] != null && resultString.event[0]['letterflag'] != 'undefined') {
	            exceptionLetterFlag = resultString.event[0]['letterflag'];
	            var exceptionTitle = "";
	            var exceptionDesc = "";
	
	            if (exceptionLetterFlag == 'REVISED') {
	                exceptionTitle = "We Have Revised Your Report";
	                exceptionDesc = "Based on our analysis and conversation we have reviewed and revised your dog’s results accordingly.";
	            } else if (exceptionLetterFlag == 'AUTODETAILED') {
	                exceptionTitle = "Detailed Refund Analysis";
	                exceptionDesc = "Based on our initial analysis we have manually reviewed your results a second time.";
	            } else if (exceptionLetterFlag == 'REPEAT') {
	                exceptionTitle = "Sample Seen Before";
	                exceptionDesc = "Based on our analysis it looks like we have seen a sample of your dog’s DNA before.";
	            } else {
	                exceptionLetterFlag = 'false';
	            }
	
	            $scope.exceptionTitle = exceptionTitle;
	            $scope.execeptionBody = exceptionDesc;
	        }
	        $scope.exceptionLetterFlag = exceptionLetterFlag;
	
	        ImageService.getImageUrl("7L4BPe98OIYYoIO4MoyOMU").then(function (response) {
	            $scope.upgradeImageUrl = response.data.fields.file.url;
	        });
	
	        ImageService.getImageUrl("69OdQqBkgo80I4Ayk22I4I").then(function (response) {
	            $scope.exceptionLetterImageUrl = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl("56Qi9YdKB2mey2GWUasMIK").then(function (response) {
	            $scope.pbddLetterImageUrl = response.data.fields.file.url;
	        });
	        ImageService.getImageUrl("3rONK4UQHekwcsScYS2C0K").then(function (response) {
	            $scope.couponCodeImageUrl = response.data.fields.file.url;
	        });
	        NavigationService.setNavigationUrls();
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	    }, function (error) {});
	}).name;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.pbddletter", []).controller('PBDDLetterController', function ($rootScope, $scope, $window, EntryService, NavigationService, FileService, TranslationService, EntryIDService, UtilityService, reportdata) {
	
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    var letter = "/staticresources/dnareports/images/" + resultString.sampleID + "/lettercontent.xml";
	    $scope.letterTest = letter;
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	    EntryService.getEntry('57xEDReh84GyeuiCsC4YCW').then(function (response) {
	        var fields = response.fields;
	        $scope.lastName = sampleDetails.ownerName.lastName;
	        $scope.firstName = sampleDetails.ownerName.firstName;
	        $scope.attentionMsg = "Attention! " + $scope.lastName;
	        var letterContent = "";
	        var letterFlag = resultString.event[0]['letterflag'];
	        $scope.date = UtilityService.formatDate(resultString.event[0]['eventDate']);
	        var outcomeFinal;
	        var resultPbDdBreed = resultString.resultPbDdBreed;
	        var breedName1 = "";
	        var breedName2 = "";
	        var pbDd = "";
	
	        if (resultPbDdBreed !== undefined && resultPbDdBreed !== null && resultPbDdBreed.length > 0) {
	            breedName1 = resultPbDdBreed[0]['breed_1'];
	            breedName2 = resultPbDdBreed[0]['breed_2'];
	            pbDd = resultPbDdBreed[0]['type'] == "Wisdom_PB" ? "PB" : resultPbDdBreed[0]['type'] == "Wisdom_DD" ? "DD" : "";
	        }
	
	        $scope.evidenceDescArray = [];
	        $scope.pbddLetterDesc = fields.pbddLetterDescription[pbDd];
	        $scope.pbddEvidences = pbDd == 'PB' ? fields.pbEvidenceDescription : pbDd == "DD" ? fields.ddEvidenceDescription : "";
	        $scope.pbddFlag = pbDd;
	        $scope.resultPbDdData = resultString.resultPbDd;
	
	        angular.forEach($scope.pbddEvidences, function (pbddData, evidence) {
	            angular.forEach($scope.resultPbDdData, function (resultSet, key) {
	                if (resultSet['evidence'].trim() == 'final_outcome') {
	                    outcomeFinal = resultSet['outcome'];
	                }
	            });
	        });
	        if (pbDd == 'PB') {
	            if (reportType != 'pdf') {
	                $rootScope.pageTitle = TranslationService.getTranslation("Notes");
	            }
	            $scope.mainDescription = $scope.pbddLetterDesc['DESCRIPTION'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME]", breedName1);
	            $scope.subject = $scope.pbddLetterDesc[outcomeFinal].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME]", breedName1);
	            $scope.commonDesc = $scope.pbddLetterDesc['COMMONDESC'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME]", breedName1).replaceAll("[BREEDTESTLINK]", "<a href='#/breedtests/nyiWblUhCo2G0o6qSis0s'>page of your report</a>");
	            $scope.letterFooter = $scope.pbddLetterDesc['LETTERFOOTER'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME]", breedName1);
	        } else if (pbDd == 'DD') {
	            if (reportType != 'pdf') {
	                $rootScope.pageTitle = TranslationService.getTranslation("Notes");
	            }
	            $scope.mainDescription = $scope.pbddLetterDesc['DESCRIPTION'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
	            $scope.subject = $scope.pbddLetterDesc[outcomeFinal].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
	            $scope.letterFooter = $scope.pbddLetterDesc['LETTERFOOTER'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
	            $scope.commonDesc = $scope.pbddLetterDesc['COMMONDESC'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME]", breedName1).replaceAll("[BREEDTESTLINK]", "<a href='#/breedtests/nyiWblUhCo2G0o6qSis0s'>page of your report</a>");
	        }
	        var init = function init() {
	            $rootScope.$broadcast('checkNotifyCount', 1);
	        };
	        init();
	        $window.ga('send', 'pageview', {
	            'page': 'PBDDLetter'
	        });
	    }, function (error) {});
	}).name;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = angular.module("mars.vet.dnareports.controllers.percentage", []).controller('PercentagesController', function ($rootScope, $scope, $window, EntryService, EntryIDService, BreedListService, NavigationService, TranslationService, UtilityService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	    EntryService.getEntry(EntryIDService.getEntryID('Ancestry')).then(function (response) {
	        var _printChartoptions;
	
	        var fields = response.fields;
	        if (reportType != 'pdf') {
	            $rootScope.pageTitle = fields.title;
	        }
	        $scope.subtitle = fields.subtitle;
	        $scope.breedtestsEntryID = EntryIDService.getEntryID('Breed Tests');
	        $scope.translation = TranslationService.getTranslation;
	        $scope.title = fields.title;
	
	        $scope.sortedBreedList = BreedListService.getSortedBreedList();
	        var data = new google.visualization.DataTable();
	        data.addColumn('string', 'Breed');
	        data.addColumn('number', 'Percentages');
	
	        var mbPosition = 0;
	
	        var colors = ['#0057b8', '#97d701', '#ff8200', '#59cbE8', '#7fabdb', '#ffc07f', '#cbeb80', '#ace5f3'];
	        var highlightColors = ['#7fabdb', '#cbeb80', '#ffc07f', '#ace5f3', '#ace5f3', '#ffc07f', '#cbeb80', '#ace5f3'];
	        var mixedBreedColors = ['#4d4d4f'];
	
	        angular.forEach(BreedListService.getSortedBreedList(), function (value, key) {
	            mbPosition++;
	            var tempArray = [value['breed'], value['count']];
	            if (value['breed'].trim() == 'Mixed Breed Groups') {
	                $scope.mixedBreedGroups = true;
	                $scope.next5 = resultString.next5;
	                colors.splice(mbPosition - 1, 0, "#4d4d4f");
	                highlightColors.splice(mbPosition - 1, 0, "#979797");
	            }
	            data.addRow(tempArray);
	        });
	
	        $scope.colors = colors;
	        $scope.highlightColors = highlightColors;
	        $scope.mixedBreedColors = mixedBreedColors;
	
	        NavigationService.setNavigationUrls();
	
	        var pieFontSize = 15;
	        var w = window.innerWidth;
	        var h = window.innerHeight;
	        if (w < 500) {
	            pieFontSize = 12;
	        }
	
	        var options = {
	            legend: 'none',
	            fontSize: pieFontSize,
	            titleTextStyle: {
	                color: '#FFFFFF'
	            },
	            'tooltip': {
	                trigger: 'none'
	            },
	            pieSliceTextStyle: {
	                color: 'white'
	            },
	            enableInteractivity: false,
	            chartArea: {
	                left: "3%",
	                top: "3%",
	                height: "80%",
	                width: "70%"
	            },
	            colors: colors
	        };
	
	        var percentagechart = new google.visualization.PieChart(document.getElementById('piechart'));
	        percentagechart.draw(data, options);
	
	
	        var printChartoptions = (_printChartoptions = {
	            width: 600,
	            height: 600,
	            legend: 'right',
	            fontSize: '8px',
	            titleTextStyle: {
	                color: '#FFFFFF'
	            }
	        }, _defineProperty(_printChartoptions, 'legend', {
	            maxLines: 2,
	            textStyle: {
	                fontSize: 15
	            }
	        }), _defineProperty(_printChartoptions, 'tooltip', {
	            trigger: 'none'
	        }), _defineProperty(_printChartoptions, 'pieSliceText', 'percentage'), _defineProperty(_printChartoptions, 'pieSliceTextStyle', {
	            color: 'white',
	            fontSize: 15
	        }), _defineProperty(_printChartoptions, 'enableInteractivity', false), _defineProperty(_printChartoptions, 'chartArea', {
	            left: 0,
	            'width': '80%',
	            'height': '80%'
	        }), _defineProperty(_printChartoptions, 'colors', colors), _printChartoptions);
	
	        if (reportType == 'pdf') {
	            var chart_div = document.getElementById('pdfpiechart');
	
	            var chart = new google.visualization.PieChart(chart_div);
	
	            google.visualization.events.addListener(chart, 'ready', function () {
	                chart_div.innerHTML = '<img src="' + chart.getImageURI() + '">';
	            });
	
	            chart.draw(data, printChartoptions);
	        }
	
	        var pbdd = resultString.pbdd;
	
	        var resultPbDdBreed = resultString.resultPbDdBreed;
	        var boBreed = resultString['boBreed'];
	        var breedName = '';
	        var index = pbdd;
	        if (resultPbDdBreed.length > 0 && resultPbDdBreed[0]['type'] == 'Wisdom_PB') {
	            breedName = resultPbDdBreed[0]['breed_1'];
	
	            if (boBreed.length > 0) {
	                angular.forEach(resultString.resultPbDd, function (value, key) {
	                    if (value['evidence'] == 'final_outcome') {
	
	                        index = value['outcome'];
	                    }
	                });
	            }
	        }
	
	        var boMegaMutt = false;
	        if (boBreed != null && boBreed.length != 0 && breedName.length != 0) {
	            $scope.disclaimer = fields.disclaimer;
	            boMegaMutt = true;
	        } else if (pbdd == 'false') {
	            var megaMuttFlag = resultString.resultDetail['megaMutt'];
	            index = megaMuttFlag === undefined || megaMuttFlag == '0' ? 'MB' : 'MM';
	        }
	        var description;
	        var pbDescription = fields.pbDescription;
	
	        var megaMutt = resultString.resultDetail['megaMutt'];
	
	        $scope.breedType = index;
	        if (megaMuttFlag !== undefined && megaMutt == 1) {
	            description = (breedName.length > 0 && boBreed.length > 0 ? pbDescription[index] + pbDescription['BodyMM'] : fields.breedwiseDescription[index]).replaceAll('[BREED NAME]', breedName);
	        } else {
	            description = (breedName.length > 0 && boBreed.length > 0 ? pbDescription[index] + pbDescription['Body'] : fields.breedwiseDescription[index]).replaceAll('[BREED NAME]', breedName);
	        }
	        $scope.descriptionArray = [];
	        angular.forEach(description.split("\n"), function (value, key) {
	            if (value != '') {
	                $scope.descriptionArray.push(value.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName));
	            }
	        });
	
	        EntryService.getEntry(EntryIDService.getEntryID('The Science')).then(function (response) {
	            var fields = response.fields;
	            $scope.description = fields.description;
	            $scope.scienceDescriptionArray = [];
	
	            angular.forEach($scope.description.split("\n"), function (value, key) {
	                if (value != '') {
	                    $scope.scienceDescriptionArray.push(value);
	                }
	            });
	        });
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	    }, function (error) {});
	}).name;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.print", []).controller('PrintReportController', function ($scope, $rootScope, EntryIDService, EntryService, BreedListService, ImageService, DisorderDataService, UtilityService, TranslationService, $timeout, $window, reportdata) {
	
	  var resultString = reportdata.resultString;
	  var sampleDetails = reportdata.sampleDetails;
	
	  $scope.getVersionFeature = UtilityService.getVersionFeature;
	
	  ImageService.getImageUrl('2wmltkOoi4woMqyqeC246q').then(function (response) {
	    $scope.downloadImageUrl = response.data.fields.file.url;
	  });
	
	  ImageService.getImageUrl('5ZHbgmta1228QASi4m0K0M').then(function (response) {
	    $scope.wisdomPanelLogoUrl = response.data.fields.file.url;
	  });
	
	  $scope.pbdd = false;
	  var resultPbDdBreed = resultString.resultPbDdBreed;
	  if (resultPbDdBreed !== undefined && resultPbDdBreed !== null && resultPbDdBreed.length > 0) {
	    $scope.pbdd = true;
	  }
	  $scope.exceptionLetter = false;
	  if (resultString.event[0] !== null && resultString.event[0] !== undefined && resultString.event[0]['letterflag'] != null && resultString.event[0]['letterflag'] != 'undefined') {
	    $scope.exceptionLetter = true;;
	  }
	
	  $scope.atRiskData = DisorderDataService.getAtRiskData();
	  $scope.carrierData = DisorderDataService.getCarrierData();
	  $scope.noCallData = DisorderDataService.getNoCallData();
	  $scope.allClearData = DisorderDataService.getAllClearData();
	
	  $scope.printreport = function () {
	    window.print();
	  };
	}).name;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.printbreed", []).controller('PrintBreedController', function ($scope, EntryIDService, EntryService, BreedListService, ImageService) {
	    'ngInject';
	
	    $scope.sortedBreedList = BreedListService.getSortedBreedList(false);
	    var breedDetails = {};
	    $scope.loaded = false;
	    var entryIdList = [];
	    angular.forEach($scope.sortedBreedList, function (value, key) {
	        if (value['breed'] != 'Mixed Breed Groups') {
	            var breedEntryId = EntryIDService.getEntryID(value['breed']);
	            entryIdList.push(breedEntryId);
	        }
	    });
	
	    angular.forEach(entryIdList, function (value, key) {
	        EntryService.getEntry(value).then(function (response) {
	            var data = response.fields;
	            var breedDetail = {};
	            breedDetail['breedName'] = data.breedName;
	            breedDetail['description'] = data.breedData['History'];
	            breedDetail['height'] = data.breedData['Height'];
	            breedDetail['weightPet'] = data.breedData['Weight Observed'];
	            breedDetail['weightShow'] = data.breedData['Weight'];
	
	            var breedCarousel = [];
	
	            var carouselImageList = response.fields.breedCarousel['CarouselImages'];
	            if ($scope.carouselImageList != '') {
	                var carouselArray = carouselImageList.split(",");
	                for (var i = 0; i < carouselArray.length; i++) {
	                    ImageService.getImageUrl(carouselArray[i]).then(function (response) {
	                        breedCarousel.push('https:' + response.data.fields.file.url);
	                    });
	                }
	            }
	            breedDetail['breedCarousel'] = breedCarousel;
	
	            var descriptionArray = [];
	
	            angular.forEach(breedDetail['description'].split("\n"), function (value, key) {
	                if (value != '') {
	                    descriptionArray.push(value);
	                }
	            });
	
	            breedDetail['descriptionArray'] = descriptionArray;
	
	            var traitsArray = [];
	
	            for (var k = 1; k <= 4; k++) {
	                traitsArray.push(data.breedData['Trait ' + k]);
	            }
	            breedDetail['traitsArray'] = traitsArray;
	
	            ImageService.getImageUrl(data.breedData['Tail']).then(function (response) {
	                breedDetail['breedTail'] = 'https:' + response.data.fields.file.url;
	            });
	            ImageService.getImageUrl(data.breedData['Muzzle']).then(function (response) {
	                breedDetail['breedMuzzle'] = 'https:' + response.data.fields.file.url;
	            });
	            ImageService.getImageUrl(data.breedData['Ear']).then(function (response) {
	                breedDetail['breedEar'] = 'https:' + response.data.fields.file.url;
	            });
	            ImageService.getImageUrl(data.breedData['Scaled Name']).then(function (response) {
	                breedDetail['breedScale'] = 'https:' + response.data.fields.file.url;
	            });
	
	            breedDetails[data.breedName] = breedDetail;
	            $scope.breedDetails = breedDetails;
	        });
	    });
	}).name;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.technology", []).controller('TechnologyController', function ($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService) {
	    'ngInject';
	
	    EntryService.getEntry(EntryIDService.getEntryID('Our Technology')).then(function (response) {
	        var fields = response.fields;
	        $rootScope.pageTitle = fields.title;
	        $scope.description = fields.description;
	        $scope.tmMessage = fields.tradeMarkMessage;
	        $scope.descriptionArray = [];
	
	        angular.forEach($scope.description.split("\n"), function (value, key) {
	            if (value != '') {
	                $scope.descriptionArray.push(value);
	            }
	        });
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	        NavigationService.setNavigationUrls();
	    });
	}).name;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.thescience", []).controller('TheScienceController', function ($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService) {
	    'ngInject';
	
	    EntryService.getEntry(EntryIDService.getEntryID('The Science')).then(function (response) {
	        var fields = response.fields;
	        $rootScope.pageTitle = fields.title;
	        $scope.description = fields.description;
	        $scope.descriptionArray = [];
	
	        angular.forEach($scope.description.split("\n"), function (value, key) {
	            if (value != '') {
	                $scope.descriptionArray.push(value);
	            }
	        });
	        NavigationService.setNavigationUrls();
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	    });
	}).name;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.traits", []).controller('TraitsController', function ($rootScope, $scope, $window, $routeParams, EntryIDService, NavigationService, EntryService, TranslationService, UtilityService, reportdata) {
	    'ngInject';
	
	    var entryID = $routeParams.entryID;
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    $scope.getVersionFeature = UtilityService.getVersionFeature('Traits');
	    var traitsData = resultString.traits;
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	    if ($scope.getVersionFeature) {
	        EntryService.getEntry(EntryIDService.getEntryID('Traits')).then(function (response) {
	            var fields = response.fields;
	            if (reportType != 'pdf') {
	                $rootScope.pageTitle = fields.title;
	            }
	            $scope.title = fields.title;
	            $scope.mainDescription = fields.description.replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);;
	            $scope.getVersionFeature = UtilityService.getVersionFeature('Traits');
	            $scope.getTranslation = TranslationService.getTranslation;
	            $window.ga('send', 'pageview', {
	                'page': $rootScope.pageTitle
	            });
	            $scope.traitsArray = traitsData;
	            NavigationService.setNavigationUrls();
	        }, function (error) {});
	    }
	}).name;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controller.ancestry", []).controller('AncestryTreeController', function ($rootScope, $scope, $window, BreedListService, EntryService, EntryIDService, ImageService, NavigationService, ChartService, BreedClusterService, TranslationService, reportdata) {
	    'ngInject';
	
	    var resultString = reportdata.resultString;
	    var sampleDetails = reportdata.sampleDetails;
	
	    var reportType = 'online';
	    $scope.onloadFun = function () {
	        reportType = 'pdf';
	    };
	    EntryService.getEntry(EntryIDService.getEntryID('Ancestry Tree')).then(function (response) {
	
	        NavigationService.setNavigationUrls();
	
	        var fields = response.fields;
	        $scope.description = fields.description;
	
	        $rootScope.pageTitle = fields.title;
	        $scope.subtitle = fields.subtitle;
	        $scope.messagebanner = fields.messageBanner;
	        $scope.msgbannerArr = [];
	        $scope.msgbannerArr = $scope.messagebanner.split("&");
	
	        $scope.traceConfidenceText = fields.traceConfidence;
	
	        $scope.traceConfidence = BreedListService.getTraceConfidence();
	
	        $scope.descriptionArray = [];
	
	        angular.forEach($scope.description.split("\n"), function (value, key) {
	            if (value != '') {
	                $scope.descriptionArray.push(value);
	            }
	        });
	
	        $scope.imgPath = "/staticresources/dnareports/images/" + resultString.sampleID + "/ancestrychart.png";
	        $scope.imgLinks = "/staticresources/dnareports/images/" + resultString.sampleID + "/ancestrychart_links.png";
	
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	        $scope.title = fields.title;
	
	        var canvasObject = document.getElementById('imagemap');
	        var ancestryChartObject = document.getElementById('ancestryChart');
	        var toolTipObject = document.getElementById('toolTipBox');
	        var canvas = document.getElementById('imagemap').getContext('2d');
	        var lastSelected = "Nothing";
	        var jsonForAncestryChart = reportdata.ancestryChartJSON;
	
	        var img = new Image();
	        img.src = "/staticresources/dnareports/images/" + resultString.sampleID + "/ancestrychart_links.png";
	
	        $(img).on('load', function () {
	            canvasObject.width = img.width;
	            canvasObject.height = img.height;
	            canvas.drawImage(img, 0, 0);
	        });
	
	        function rgbToHex(R, G, B) {
	            return toHex(R) + toHex(G) + toHex(B);
	        }
	
	        function toHex(n) {
	            n = parseInt(n, 10);
	            if (isNaN(n)) {
	                return "00";
	            }
	            n = Math.max(0, Math.min(n, 255));
	            return "0123456789ABCDEF".charAt((n - n % 16) / 16) + "0123456789ABCDEF".charAt(n % 16);
	        }
	
	        function loadJSONAncestryChart(jsonAncestryChartFile) {
	            $.getJSON(jsonAncestryChartFile, function (response) {
	                jsonForAncestryChart = response.data.fields.file.url;
	            });
	        }
	
	        function selectCurrentBreed(event) {
	
	            var currentArray = findCellObjectFromRGB(event);
	
	            if (currentArray === "Nothing") {
	                lastSelected = "Nothing";
	                $('#result input').val(lastSelected);
	            } else {
	                var combinationText = "";
	
	                for (var breed = 0; breed < currentArray.length; breed++) {
	                    var breedString = currentArray[breed].breed;
	                    combinationText += breedString;
	                    if (breed < currentArray.length - 1) {
	                        combinationText += ", ";
	                    }
	                }
	
	                lastSelected = currentArray;
	
	                $('#result input').val(combinationText);
	            }
	        }
	
	        function clickCurrentBreed(event) {
	
	            if (lastSelected === "Nothing") {
	                clearBox();
	            } else if (lastSelected.length == 1) {
	                linkToBreeds(lastSelected[0].breed);
	            } else {
	
	                var x = event.pageX;
	                var y = event.pageY;
	
	                toolTipObject.width = 1 + "px";
	                toolTipObject.height = 1 + "px";
	                toolTipObject.style.display = "block";
	                var linkTextInToolTip = "";
	
	                for (var i = 0; i < lastSelected.length; i++) {
	                    var breed = lastSelected[i].breed;
	                    if (breed == "Mixed Breed") {
	                        linkTextInToolTip += "<a href=#/mixedbreedgroups/" + EntryIDService.getEntryID("Mixed Breed Groups") + ">" + breed + "</a><br/>";
	                    } else {
	                        linkTextInToolTip += "<a href=#/breed/" + EntryIDService.getEntryID(breed) + ">" + breed + "</a><br/>";
	                    }
	                }
	                toolTipObject.innerHTML = linkTextInToolTip;
	
	                var x = event.pageX;
	                var y = event.pageY;
	
	                toolTipObject.style.left = x + "px";
	                toolTipObject.style.top = y + "px";
	            }
	        }
	
	        function findCellObjectFromRGB(event) {
	            var x = event.pageX - ancestryChartObject.offsetLeft;
	            var y = event.pageY - ancestryChartObject.offsetTop;
	
	            var xProp = x / ancestryChartObject.width;
	            var yProp = y / ancestryChartObject.height;
	
	            var img_data = canvas.getImageData(xProp * img.width, yProp * img.height, 1, 1).data;
	
	            var R = img_data[0];
	            var G = img_data[1];
	            var B = img_data[2];
	
	            var rgb = R + ',' + G + ',' + B;
	
	            var hex = rgbToHex(R, G, B);
	
	            $('#rgb input').val(rgb);
	            $('#hex input').val('#' + hex);
	
	            var returnValue = "";
	
	            if (hex in jsonForAncestryChart) {
	                returnValue = jsonForAncestryChart[hex];
	            } else {
	                returnValue = "Nothing";
	            }
	
	            return returnValue;
	        }
	
	        function changeMouse() {
	            var currentArray = findCellObjectFromRGB(event);
	
	            if (currentArray === "Nothing") {
	                ancestryChartObject.style.cursor = "auto";
	            } else {
	                ancestryChartObject.style.cursor = "pointer";
	            }
	        }
	
	        function linkToBreeds(breed) {
	            if (breed == "Mixed Breed") {
	                window.location = "#/mixedbreedgroups/" + EntryIDService.getEntryID("Mixed Breed Groups");
	            } else {
	                window.location = "#/breed/" + EntryIDService.getEntryID(breed);
	            }
	            clearBox();
	            $('#final input').val(breed);
	        }
	
	        function clearBox() {
	            toolTipObject.style.display = "none";
	            ancestryChartObject.style.cursor = "auto";
	        }
	
	        $('#ancestryChart').click(function (event) {
	            selectCurrentBreed(event);
	            clickCurrentBreed(event);
	        });
	
	        $('#ancestryChart').mousemove(function (event) {
	            changeMouse(event);
	        });
	
	        $scope.petName = sampleDetails.petDetails.petName;
	    }, function (error) {});
	}).name;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.learnmoretraits", []).controller('LearnMoreTraitsController', function ($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService) {
	
	    EntryService.getEntry(EntryIDService.getEntryID('LearnMoreTraits')).then(function (response) {
	        var fields = response.fields;
	        $rootScope.pageTitle = fields.title;
	        $scope.traitTypes = fields.traits.traitTypes;
	        $window.ga('send', 'pageview', {
	            'page': $rootScope.pageTitle
	        });
	        NavigationService.setNavigationUrls();
	    });
	}).name;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = angular.module("mars.vet.dnareports.controllers.upgrademodal", []).controller('UpgradeModalController', function ($scope, $uibModalInstance, EntryIDService, EntryService, reportdata) {
		'ngInject';
	
		var upgradeUrl = "";
	
		var resultString = reportdata.resultString;
	
		EntryService.getEntry(EntryIDService.getEntryID('Upgrade')).then(function (response) {
	
			var fields = response.fields;
	
			$scope.close = function () {
				$modalInstance.dismiss('cancel');
			};
			var modalOptions = {
				headerText: fields.upgradeText,
				upgradeUrl: fields.upgradeUrl.replace("<sampleID>", resultString.sampleID),
				ok: upgradeNow,
				close: learnMore,
				dismiss: dismiss
			};
			$scope.modalOptions = modalOptions;
	
			upgradeUrl = modalOptions.upgradeUrl;
		}, function (error) {});
	
		var upgradeNow = function upgradeNow() {
			window.open(upgradeUrl, '_blank');
			$uibModalInstance.close();
		};
		var learnMore = function learnMore() {
			$uibModalInstance.close();
		};
		var dismiss = function dismiss() {
			$uibModalInstance.close();
		};
	}).name;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	/*function printreport() {
	    var divElements = document.getElementById('pdfContainer').innerHTML;
	    var oldPage = document.body.innerHTML;
	    document.body.innerHTML = "<html><head><title></title></head><body>" +
	        divElements + "</body>";
	    window.print();
	    document.body.innerHTML = oldPage;
	}
	
	<<<<<<< HEAD:dnareports/js/util/utility.js
	
	*/
	
	/*String.prototype.replaceAll = function(s, r) {
	=======
	String.prototype.replaceAll = function(s, r) {
	>>>>>>> 4c76ab1e7d4e66ec68e6a2822c309c77a222c72a:client/apps/util/utility.js
	    return this.split(s).join(r)
	}*/
	
	


/***/ })
]);


// WEBPACK FOOTER //
// app.c9b121d9444e0d158dfb.js